<template>
  <v-container grid-list-xl notificationContainer style="overflow: hidden !important;">
    <v-form>
      <v-layout row wrap>
        <div v-show="viewList == true">
          <div style="float: left;width: 25%;" v-if="objAuthorize.department_active == 1">
            <!--<v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />-->
            <v-select @input="fncFilterNotifications()" class="shortSelect" v-model="subDepartmentFilter" :items="notificationDepartmentList" item-text="name" item-value="id" solo outline></v-select><br />
          </div>
          <v-btn color="success" class="text-xs-right" @click.stop="fncToggleDisplay()"><i class="material-icons">add</i>Add New Notification</v-btn>
          <v-data-table loading="true" :headers="notificationHeader" :items="notificationListSet" hide-actions disable-initial-sort class="elevation-1">
            <template slot="items" slot-scope="props">
              <tr class="sortableRow">
                <td width="35%">{{ props.item.name }}</td>
                <td width="10%" v-if="props.item.departments == '' || props.item.departments == '0' || props.item.departments == null">N/A</td>
                <td width="10%" v-else>
                  <v-tooltip bottom style="top: 0px !important;">
                    <p slot="activator" style="cursor:pointer;padding-top: 14px;float:left;display: block;">View Departments</p>
                    <span v-html="fncGetDepartment(props.item.departments)"></span>
                  </v-tooltip>
                </td>
                <td width="20%">{{ fncGetType(props.item.type_id) }}</td>
                <td width="10%"><a @click.prevent="fncEditNotification(props.index)"><i class="material-icons">edit</i></a></td>
                <td width="10%"><a @click.prevent="fncDeleteNotifications(props.item)"><i class="material-icons">delete_forever</i></a></td>
                <td width="15%"><v-switch @change="fncChangeState( props.item.id, props.item.state )" v-model="props.item.state"></v-switch></td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <v-flex lg12 v-if="viewList == false" style="padding-left: 0px !important;">
          <!--<v-btn color="success" class="text-xs-right floatLeft" @click.stop="fncToggleDisplay()"><i class="material-icons">arrow_left</i>All Notifications</v-btn>-->
          <v-btn v-if="notificationId !== ''" :disabled="fncCheckNotificationAction()" class="text-xs-right floatLeft importantButton" @click.stop="fncUpdateNotification()">Update</v-btn>
          <v-btn v-if="notificationId === ''" :disabled="fncCheckNotificationAction()" class="importantButton text-xs-right floatLeft" @click.stop="fncAddNotification()">Add</v-btn>
          <small style="padding-top: 16px;display:block;padding-left: 12px;float: left;">* Button will activate when all * COMPULSORY fields have been filled in</small>
        </v-flex>
        <v-tabs :key="notificationFormKey" v-show="viewList == false" slider-color="grey" class="notificationsTabs">
          <v-tab class="tab" :key="1" ref="startTab" ripple>General</v-tab>
          <v-tab class="tab" :key="2" v-if="fncCheckMethodList('email') && ( this.notifyRep == true || this.notifyVendor == true || this.notifyVendor == false || this.notifyOriginator == true || this.notifyKam == true || this.notifyCoordinator == true )" ripple>Internal Email</v-tab>
          <v-tab class="tab" :key="2" disabled v-else ripple>Internal Email</v-tab>
          <v-tab class="tab" :key="3" v-if="fncCheckMethodList('sms') && notifyDaily == false && ( this.notifyRep == true || this.notifyVendor == true || this.notifyOriginator == true || this.notifyKam == true || this.notifyCoordinator == true )" ripple>Internal Whatsapp</v-tab>
          <v-tab class="tab" :key="3" disabled v-else ripple>Internal Whatsapp</v-tab>
          <v-tab class="tab" :key="4" v-if="fncCheckMethodList('email') && notifyCustomer == true && notifyDaily == false" ripple>Customer Email</v-tab>
          <v-tab class="tab" :key="4" disabled v-else ripple>Customer Email</v-tab>
          <v-tab class="tab" :key="5" v-if="fncCheckMethodList('sms') && notifyCustomer == true && notifyDaily == false" ripple>Customer Whatsapp</v-tab>
          <v-tab class="tab" :key="5" disabled v-else ripple>Customer Whatsapp</v-tab>
          <v-tab class="tab" :key="6" v-if="apiData.isApi == true || apiData.isApi == 'true'" ripple>API</v-tab>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">
            <v-container grid-list-xl style="padding-top: 0px !important;height: 60vh; padding-bottom: 40px !important;">
              <v-layout row wrap>
                <v-flex lg3 v-if="objAuthorize.email == 'superuser@ndtec.co.za' || objAuthorize.email == 'bwsuperuser@ndtec.co.za'">
                  <label class="blackLabel">API call:</label>
                  <small>Is this an API call?</small>
                  <v-switch v-model="apiData.isApi"></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">* Notification Name:</label>
                  <small>Provide a unique description for this Notification</small>
                  <v-text-field @input="fncSetModalTitle()" placeholder="Notification Name" v-model="notificationName" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg3 v-if="apiData.isApi == false">
                  <label class="blackLabel">* Notification Type:</label>
                  <small>How do you want Notifications to be triggered</small>
                  <v-select :items="notificationTypes" placeholder="Notification Type" @input="fncCheckType" class="dropdown" v-model="notificationType" item-value="id" item-text="name" solo></v-select>
                </v-flex>
                <v-flex lg3 v-if="notificationType == 3">
                  <label class="blackLabel">* Notification Status From:</label>
                  <small>From what status would you like notifications?</small>
                  <v-select :items="statusList" placeholder="Notification Status From" class="dropdown" v-model="notifyStatusStatus" item-value="id" item-text="description" autocomplete solo></v-select>
                </v-flex>
                <v-flex lg3 v-show="notificationType == 3">
                  <label class="blackLabel">* Number of Days of non change:</label>
                  <small>Trigger notification after how many days of no change in status?</small>
                  <v-text-field placeholder="Days" type="number" min="0" v-model="notifyStatusDays" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg3 v-show="notificationType == 3">
                  <label class="blackLabel">* Number of Hours of non change:</label>
                  <small>And/or how many hours?</small>
                  <v-text-field placeholder="Hours" type="number" min="0" v-model="notifyStatusHours" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg3 v-if="apiData.isApi == false">
                  <label class="blackLabel">* Notification Timing:</label>
                  <small>When should this notification be sent?</small>
                  <v-select :items="notificationReportTypes" placeholder="Notification Report Type" @input="fncCheckDaily" class="dropdown" v-model="notifyDaily" item-value="id" item-text="name" solo></v-select>
                </v-flex>
                <v-flex lg3 v-show="notifyDaily ==  true">
                  <label class="blackLabel">* Notification Time:</label>
                  <small>When should the notification be sent</small>
                  <v-select :items="notificationTimes" placeholder="Notification Time" class="dropdown" v-model="notificationTime" item-value="id" item-text="name" solo></v-select>
                </v-flex>
                <v-flex lg3 v-show="( notifyDaily == true || notificationType == 2 ) && notificationType != 3">
                  <label class="blackLabel">* Number of Days:</label>
                  <small v-if="this.notificationType == 2">Trigger notification after how many days of no change in status?</small>
                  <small v-if="this.notificationType == 1">Include quotes that were changed to status in the last how many day/s</small>
                  <small v-if="this.notificationType == ''">-</small>
                  <v-text-field placeholder="Days" type="number" min="0" v-model="notificationDays" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg3 v-show="( notifyDaily == true || notificationType == 2 ) && notificationType != 3">
                  <label class="blackLabel">* Number of Hours:</label>
                  <small>And/or how many hours?</small>
                  <v-text-field placeholder="Hours" type="number" min="0" v-model="notificationHours" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg3 v-if="this.notifyRep == true && apiData.isApi == false">
                  <label class="blackLabel">* Who needs to be notified?</label>
                  <small>
                      Select {{ objAuthorize.manu_user_alias }} roles to be notified
                    <v-tooltip left style="top: 0px !important;">
                      <i style="display: inline-block; font-size: 16px;float: right;margin-top: -18px; margin-right: 8px;" slot="activator" class="material-icons">info</i>
                      <span>Select {{ objAuthorize.manu_user_alias }} roles to be notified, that are also linked to the departments selected in the "Notification Department" section</span>
                    </v-tooltip>
                  </small>
                  <v-select :items="filteredUserTypes" @input="fncCheckForVendor" placeholder="Notification Roles" class="dropdown" v-model="notificationRole" item-value="id" item-text="name" multiple outline autocomplete></v-select>
                </v-flex>
                <v-flex lg3 v-if="apiData.isApi == false && notifyDaily == false">
                  <label class="blackLabel">If this role is present do not send this notification at all</label>
                  <small>
                    If a User with the below Role is linked to quote, don’t sent this notification for that quote
                  </small>
                  <v-select :items="filteredUserTypes" placeholder="Notification Roles To Ignore" class="dropdown" v-model="notificationRoleIgnore" item-value="id" item-text="name" multiple outline autocomplete></v-select>
                </v-flex>
                <!--<v-flex lg3 v-if="this.notifyRep == true && apiData.isApi == false">
                  <label class="blackLabel">* Which roles should be ignored?</label>
                  <small>
                    Select {{ objAuthorize.manu_user_alias }} roles to be ignored
                    <v-tooltip left style="top: 0px !important;">
                      <i style="display: inline-block; font-size: 16px;float: right;margin-top: -18px; margin-right: 8px;" slot="activator" class="material-icons">info</i>
                      <span>Select {{ objAuthorize.manu_user_alias }} roles to be ignored, the notification will not send if a quote contains this role</span>
                    </v-tooltip>
                  </small>
                  <v-select :items="filteredUserTypes" @input="fncCheckForVendor" placeholder="Notification Roles" class="dropdown" v-model="notificationRole" item-value="id" item-text="name" multiple outline></v-select>
                </v-flex>-->
                <v-flex lg3 v-if="apiData.isApi == false && notifyDaily == true">
                  <label class="blackLabel">* Notification Per Store:</label>
                  <small>Should users only receive store related quotes</small>
                  <v-switch v-model="notifyIsStore"></v-switch>                
                </v-flex>
                <v-flex lg3 v-show="apiData.isApi == false && notifyDaily == true">
                  <label class="blackLabel">* Notification Days:</label>
                  <small>What days do you want to send notification on</small>
                  <v-select :items="notificationSendDaysItems" placeholder="Notification Days" class="dropdown" v-model="notificationSendDays" item-value="id" item-text="name" multiple outline></v-select>
                  <!-- @input="fncCheckDays" -->
                </v-flex>
                <v-flex lg3 v-if="apiData.isApi == false">
                  <label class="blackLabel">* Notification Method:</label>
                  <small>How do you want to send the notification</small>
                  <v-select :items="notificationMethods" placeholder="Notification Method" class="dropdown" v-model="notificationMethod" item-value="id" item-text="name" multiple outline></v-select>
                </v-flex>
                <v-flex lg3 class="noArrows" v-if="apiData.isApi == false">
                  <label class="blackLabel">Quote Value Threshold (incl of VAT):</label>
                  <small>Quotes under this value will be Ignored</small>
                  <v-text-field placeholder="Quote Value" v-model="notificationValue" type="number" min="0" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg3 v-if="apiData.isApi == false">
                  <label class="blackLabel">Exclude Quotes Generated More Than</label>
                  <small>Number of days ago</small>
                  <v-text-field placeholder="Quote Value" v-model="notificationAge" type="number" min="0" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg3 v-if="apiData.isApi == false">
                  <label class="blackLabel">Direct Reports</label>
                  <small>Email the report to a specific user</small>                
                  <v-select :items="repUsers" placeholder="Direct Report" class="dropdown" v-model="notificationDirectReport" item-value="id" item-text="label" solo multiple autocomplete></v-select>
                  <!--<v-select :items="repUsers" @input="fncCheckBranches" placeholder="Direct Report" class="dropdown" v-model="notificationDirectReport" item-value="id" item-text="label" solo multiple></v-select>-->
                </v-flex>
                <v-flex lg3 v-show="notifyDaily == false && apiData.isApi == false" class="greenDot">
                  <label class="blackLabel">Notify {{ objAuthorize.manu_user_alias }} roles:</label>
                  <small>Send the rep a message as well</small>
                  <v-switch :label="fncGetRepFlag()" @change="fncCheckRoles()" v-model="notifyRep"></v-switch>
                </v-flex>
                <v-flex lg3 v-show="notifyDaily == false && apiData.isApi == false" class="greenDot">
                  <label v-if="notifyDaily == false" class="blackLabel">Notify Customer:</label>
                  <small v-if="notifyDaily == false">Send the customer a message as well</small>
                  <v-switch v-if="notifyDaily == false" :label="fncGetCustomerFlag()" v-model="notifyCustomer"></v-switch>
                </v-flex>
                <v-flex lg3 v-show="notifyDaily == false && apiData.isApi == false" class="greenDot">
                  <label v-if="notifyDaily == false" class="blackLabel">Notify Vendor:</label>
                  <small v-if="notifyDaily == false">Send the vendor a message as well</small>
                  <v-switch v-if="notifyDaily == false" @change="notifyVendorEventListener($event)" v-model="notifyVendor"></v-switch>
                </v-flex>
                <v-flex lg3 v-show="notifyDaily == false && apiData.isApi == false" class="greenDot">
                  <label v-if="notifyDaily == false" class="blackLabel">Notify Originator:</label>
                  <small v-if="notifyDaily == false">Send the originator a message as well</small>
                  <v-switch v-if="notifyDaily == false" v-model="notifyOriginator"></v-switch>
                </v-flex>
                <v-flex lg3 v-show="notifyDaily == false && apiData.isApi == false" class="greenDot">
                  <label v-if="notifyDaily == false" class="blackLabel">Is this a Call Out Notification:</label>
                  <small v-if="notifyDaily == false">Send if it is a callout quote</small>
                  <v-switch v-if="notifyDaily == false" v-model="isCallout"></v-switch>
                </v-flex>
                <!--<v-flex lg3 v-show="notifyDaily == false && apiData.isApi == false" class="greenDot">
                  <label v-if="notifyDaily == false" class="blackLabel">Notify Commercial KAM:</label>
                  <small v-if="notifyDaily == false">Send the commercial kam a message as well</small>
                  <v-switch v-if="notifyDaily == false" v-model="notifyKam"></v-switch>
                </v-flex>
                <v-flex lg3 v-show="notifyDaily == false && apiData.isApi == false" class="greenDot">
                  <label v-if="notifyDaily == false" class="blackLabel">Notify Commercial Coordinator:</label>
                  <small v-if="notifyDaily == false">Send the commercial coordinator a message as well</small>
                  <v-switch v-if="notifyDaily == false" v-model="notifyCoordinator"></v-switch>
                </v-flex>-->
                <v-flex lg3 v-if="this.notifyVendor == true && apiData.isApi == false">
                  <label class="blackLabel">* Vendor roles needs to be notified?</label>
                  <small>Select vendor roles to be notified</small>
                  <v-select :items="filteredUserTypesVendors" @input="fncCheckForVendor" placeholder="Notification Roles" class="dropdown" v-model="notificationRole" item-value="id" item-text="name" multiple outline autocomplete></v-select>
                </v-flex>
                <v-flex lg3 v-if="hasVendorRole == true && vendorManufacturerLinks.length > 0">
                  <label class="blackLabel">Vendors to Notify:</label>
                  <small>Notify which Vendors</small>
                  <v-select :items="vendorManufacturerLinks" @input="fncCheckVendors" placeholder="Vendors to Notify" class="dropdown" v-model="notificationVendors" item-value="id" item-text="name" autocomplete multiple outline autocomplete></v-select>
                </v-flex>
                <v-flex v-if="objAuthorize.branch_active == true && branchList.length > 0 && apiData.isApi == false" lg3>
                  <label class="blackLabel">* Notification Store:</label>
                  <small>Send the notification for specific stores</small>
                  <v-select :items="branchList" @input="fncCheckBranches" placeholder="Notification Stores" class="dropdown" v-model="notificationBranches" item-value="id" item-text="name" solo multiple autocomplete></v-select>
                </v-flex>
                <v-flex v-if="objAuthorize.department_active == true && departmentList.length > 0 && apiData.isApi == false" lg3>
                  <label class="blackLabel">* Notification Department:</label>
                  <small>Send the notification for specific departments</small>
                  <v-select :items="departmentListSet" @input="fncCheckDepartments" placeholder="Notification Departments" class="dropdown" v-model="notificationDepartments" item-value="id" item-text="name" solo multiple autocomplete></v-select>
                </v-flex>
                <!-- Vendor List -->
                <v-flex v-if="vendorManufacturerLinks.length > 0 && apiData.isApi == false" lg3>
                  <label class="blackLabel">* Notification Report Vendors:</label>
                  <small>Show quotes to Builders users for selected Vendors</small>
                  <v-select :items="vendorManufacturerLinks" placeholder="Notification Vendors" class="dropdown" v-model="notificationReportVendors" item-value="id" item-text="name" solo multiple autocomplete></v-select>
                </v-flex>
                <v-flex v-show="notifyDaily == false && apiData.isApi == false" lg3>
                  <label class="blackLabel">* Notification Quote Type:</label>
                  <small>Send notification for specific quote type</small>
                  <v-select :items="quoteTypes" placeholder="Notification Quote Type" class="dropdown" v-model="notificationQuoteType" item-value="id" item-text="name" solo autocomplete></v-select>
                </v-flex>
                <v-flex v-show="notifyDaily == false && apiData.isApi == false" lg3>
                  <label class="blackLabel">* Notification Service Type:</label>
                  <small>Send notification for specific service type</small>
                  <v-select :items="serviceTypes" placeholder="Notification Quote Type" class="dropdown" v-model="notificationServiceType" item-value="id" item-text="name" solo autocomplete></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2" style="overflow: hidden !important;">
            <v-container grid-list-xl style="padding-top: 0px !important;">
              <v-layout row wrap>
                <p v-show="!fncCheckMethodList('email')"><br /><strong>Please select a Notification Method under the General Tab to enable this screen.</strong></p>
                <v-flex lg4 v-show="fncCheckMethodList('email')" style="padding-top: 0px !important; padding-bottom: 0px !important;overflow:hidden !important;">
                  <v-switch class="switchSmall pdfSwitch"  v-if="notifyDaily === false" label="Attach the quote PDF" style="margin-top: 0px;" v-model="notifyAddPdf"></v-switch>
                  <v-switch class="switchSmall pdfSwitch" v-if="notifyDaily === false && objAuthorize.po_template != ''" label="Attach the Purchase Order PDF" style="margin-top: -6px;" v-model="notifyAddPoPdfVendor"></v-switch>
                  <!--<label class="blackLabel" style="margin-top: 5px !important;">Usable Shortcode:</label>-->
                  <div class="shortcodes">
                    <h3 style="font-size:12px !important;">Originator Details</h3>
                    <div title="Add the Sales Rep's first name to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[REP_NAME]', 'rep')">[REP_NAME]</div>
                    <div title="Add the Sales Rep's surname to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[REP_SURNAME]', 'rep')">[REP_SURNAME]</div>
                    <div title="Add the Sales Rep's email address to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[REP_EMAIL]', 'rep')">[REP_EMAIL]</div>
                    <div title="Add the Sales Rep's telephone number to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[REP_TEL]', 'rep')">[REP_TEL]</div>
                    <div title="Add your business name to the message" @click="fncSetShortcode('[YOUR_COMPANY_NAME]', 'rep')">[YOUR_COMPANY_NAME]</div>
                  </div>
                  <div class="shortcodes">
                    <h3 style="font-size:12px !important;">Customer Details</h3>
                    <div title="Add the Customer's first name to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[CUSTOMER_NAME]', 'rep')">[CUSTOMER_NAME]</div>
                    <div title="Add the Customer's surname to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[CUSTOMER_SURNAME]', 'rep')">[CUSTOMER_SURNAME]</div>
                    <div title="Add the Customer's email address to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[CUSTOMER_EMAIL]', 'rep')">[CUSTOMER_EMAIL]</div>
                    <div title="Add the Customer's telephone number to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[CUSTOMER_TEL]', 'rep')">[CUSTOMER_TEL]</div>
                    <div title="Add the Customer's company to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[CUSTOMER_COMPANY]', 'rep')">[CUSTOMER_COMPANY]</div>
                    <div title="Add the Customer's Delivery Details to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[CUSTOMER_DELIVERY_DETAILS]', 'rep')">[CUSTOMER_DELIVERY_DETAILS]</div>
                    <div title="Add the Customer Recipient to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_CUSTOMER_RECIPIENT]', 'rep')">[QUOTE_CUSTOMER_RECIPIENT]</div>
                  </div>
                  <div class="shortcodes">
                    <h3 style="font-size:12px !important;margin-top: 20px !important;">Recipient Details</h3>
                    <div :title="fncRecName()" @click="fncSetShortcode('[RECIPIENT_NAME]', 'rep')">[RECIPIENT_NAME]</div>
                    <div :title="fncRecSurname()" @click="fncSetShortcode('[RECIPIENT_SURNAME]', 'rep')">[RECIPIENT_SURNAME]</div>
                    <div :title="fncRecEmail()" @click="fncSetShortcode('[RECIPIENT_EMAIL]', 'rep')">[RECIPIENT_EMAIL]</div>
                    <h3 style="font-size:12px !important;margin-top: 20px !important;">Quote Details</h3>
                    <div title="Add the direct link to the quote" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_DIRECT_LINK]', 'rep')">[QUOTE_DIRECT_LINK]</div>
                    <div title="Add the direct link to the quote" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_DIRECT_LINK_PURCHASE_ORDER]', 'rep')">[QUOTE_DIRECT_LINK_PURCHASE_ORDER]</div>
                    <div title="Add the sales order number" v-if="notifyDaily === false" @click="fncSetShortcode('[SALES_ORDER_NUMBER]', 'rep')">[SALES_ORDER_NUMBER]</div>
                    <div title="Add the store to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_STORE]', 'rep')">[QUOTE_STORE]</div>
                    <div title="Add the reason for status" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_STATUS_REASON]', 'rep')">[QUOTE_STATUS_REASON]</div>
                    <div title="Add the time the status has not changed" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_TIME_IN_STATUS]', 'rep')">[QUOTE_TIME_IN_STATUS]</div>
                    <div title="Add the Service Form type" v-if="notifyDaily === false" @click="fncSetShortcode('[SERVICE_TYPE]', 'rep')">[SERVICE_TYPE]</div>
                    <div title="Add the Project" v-if="notifyDaily === false" @click="fncSetShortcode('[PROJECT]', 'rep')">[PROJECT]</div>
                    <div title="Add the Department" v-if="notifyDaily === false" @click="fncSetShortcode('[DEPARTMENT]', 'rep')">[DEPARTMENT]</div>
                    <div title="Add the Notes" v-if="notifyDaily === false" @click="fncSetShortcode('[NOTES]', 'rep')">[NOTES]</div>
                  </div>
                  <div class="shortcodes">
                    <h3 style="font-size:12px !important;margin-top: 20px !important;">Quote Details</h3>
                    <div title="Add the quote date to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_DATE]', 'rep')">[QUOTE_DATE]</div>
                    <div title="Add the quote number to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_NO]', 'rep')">[QUOTE_NO]</div>
                    <div title="Add the current quote status to the message" @click="fncSetShortcode('[QUOTE_STATUS]', 'rep')">[QUOTE_STATUS]</div>
                    <div title="Add a summary of the quote to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_SUMMARY]', 'rep')">[QUOTE_SUMMARY]</div>
                    <div title="Add the quote vat total to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_TOTAL_VATEXCL]', 'rep')">[QUOTE_TOTAL_VATEXCL]</div>
                    <div title="Add the quote total including vat to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_TOTAL_VATINCL]', 'rep')">[QUOTE_TOTAL_VATINCL]</div>
                    <div title="Add buttons for the customer to Accept/Reject a quote to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_ACCEPT_REJECT]', 'rep')">[QUOTE_ACCEPT_REJECT]</div>
                    <!--<div title="Add buttons for the customer to Final Accept/Reject a quote to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_ACCEPT_REJECT_FINAL]', 'rep')">[QUOTE_ACCEPT_REJECT_FINAL]</div>-->
                    <div title="Add the sales order number to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_SO_NUMBER]', 'rep')">[QUOTE_SO_NUMBER]</div>
                    <div title="Add the purchase order number to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_PO_NUMBER]', 'rep')">[QUOTE_PO_NUMBER]</div>
                    <!--<div title="Add the commercial kam" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_COMMERCIAL_KAM]', 'rep')">[QUOTE_COMMERCIAL_KAM]</div>
                    <div title="Add the commercial kam" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_COMMERCIAL_COORDINATOR]', 'rep')">[QUOTE_COMMERCIAL_COORDINATOR]</div>-->
                    <div title="Add the Transaction ID" v-if="notifyDaily === false" @click="fncSetShortcode('[TRANSACTION_ID]', 'rep')">[TRANSACTION_ID]</div>
                    <div title="Add the Shipping Tracking Number" v-if="notifyDaily === false" @click="fncSetShortcode('[SHIPPING_TRACKING_NO]', 'rep')">[SHIPPING_TRACKING_NO]</div>
                    <div title="Add the Shipping Tracking URL" v-if="notifyDaily === false" @click="fncSetShortcode('[SHIPPING_TRACKING_URL]', 'rep')">[SHIPPING_TRACKING_URL]</div>
                    <div title="Add the Shipping Date / Time" v-if="notifyDaily === false" @click="fncSetShortcode('[SHIPPING_DATE_TIME]', 'rep')">[SHIPPING_DATE_TIME]</div>
                    <div title="Add the Company" v-if="notifyDaily === false" @click="fncSetShortcode('[COMPANY]', 'rep')">[COMPANY]</div>
                    <div title="Add the list of linked quotes" v-if="notifyDaily === false" @click="fncSetShortcode('[LINKED_QUOTES]', 'rep')">[LINKED_QUOTES]</div>
                    <div title="Add the list of linked quotes" v-if="notifyDaily === false" @click="fncSetShortcode('[SERVICE_FORM_REASON]', 'rep')">[SERVICE_FORM_REASON]</div>
                    <div title="Add Quote Memo" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_MEMO]', 'rep')">[QUOTE_MEMO]</div>
                    <div title="Add Quote External Ref" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_EXTERNAL_REF]', 'rep')">[QUOTE_EXTERNAL_REF]</div>                  
                  </div>
                </v-flex>
                <v-flex lg6 id="reps" v-if="fncCheckMethodList('email') && this.internalEmailPreview == false" style="padding-bottom: 0px !important">
                  <label style="display: block;float:left; width:10% !important;padding-top: 10px;" class="blackLabel">* Subject:</label>
                  <v-text-field placeholder="Subject" style="display: block;float:left; width:45% !important;" v-model="notificationSubject" single-line solo></v-text-field>
                  <small style="display: block;float:left; width:30% !important;padding-top: 12px !important;">&nbsp;&nbsp;Subject line of the Email</small>
                  <div style="clear:both;"></div>
                  <!--{{ attachmentCategories }}
                  {{ userRoles }}-->
                  <label class="blackLabel" style="margin-top: 20px !important;">* Create Message Text:</label>
                  <small>Set up the message that will be sent to the selected internal roles.  Insert the shortcode variables into your message template by clicking on them from the desired part of your text. <span style="font-weight:bold;cursor:pointer;text-decoration:underline;" @click.stop="fncShowInternalEmailPreview(true)">VIEW EXAMPLE</span></small>
                  <v-text-field v-if="objAuthorize.privileges.indexOf('CAN_PASTE_NOTIFICATIONS') == -1" rows="10" @focus="fncDisablePaste()" placeholder="Rep Email Text" id="repText" v-model="repWysiwig" multi-line solo></v-text-field>
                  <v-text-field v-if="objAuthorize.privileges.indexOf('CAN_PASTE_NOTIFICATIONS') != -1" rows="10" placeholder="Rep Email Text" id="repText" v-model="repWysiwig" multi-line solo></v-text-field>
                </v-flex>
                <v-flex lg7 v-if="fncCheckMethodList('email') && this.internalEmailPreview == true">
                  <small><span style="display: block !important; float:left !important;">Message that will be sent to selected internal roles </span> <span style="margin-left: 5px !important;font-weight:bold;cursor:pointer;text-decoration:underline; display:block !important; float: left !important;" @click.stop="fncShowInternalEmailPreview(false)">HIDE EXAMPLE</span></small>
                  <div style="white-space: pre-line !important;" v-html="fncContentInternalEmail()"></div>
                </v-flex>
                <v-flex lg2>
                    <h3 style="font-size:12px !important;margin-top: 0px !important;">Add Attachment Categories</h3>
                    <v-select :items="attachmentCategories" placeholder="Notification Attachment Categories" class="dropdown" v-model="notificationCats" item-value="id" item-text="name" multiple outline></v-select>
                    <h3 style="font-size:12px !important;margin-top: 00px !important;">Add Roles Shortcode</h3>
                    <v-select :items="userRoles" placeholder="Notification User Roles" @input="fncSetRole" v-model="shortRole" class="dropdown" item-value="id" item-text="name" solo></v-select>
                    <br /><h3 style="font-size:12px !important;margin-top: 00px !important;">Add Status Button</h3>
                    <v-select :items="statusList" placeholder="Notification Status Button" @input="fncSetStatus" v-model="shortStatus" class="dropdown" item-value="id" item-text="description" solo></v-select>
                    <br /><v-switch class="switchSmall pdfSwitch"  v-if="notifyDaily === false" label="Attach the full service form" style="margin-top: 0px;" v-model="attachServiceFormFull"></v-switch>
                    <v-switch class="switchSmall pdfSwitch"  v-if="notifyDaily === false" label="Attach the customer service form" style="margin-top: 0px;" v-model="attachServiceFormClient"></v-switch>
                  <v-switch class="switchSmall pdfSwitch"  v-if="notifyDaily === false" label="Attach Delivery Note" style="margin-top: 0px;" v-model="attachDeliveryNote"></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3">
            <v-container grid-list-xl style="padding-top: 0px !important;">
              <v-layout row wrap>
                <p v-show="!fncCheckMethodList('sms') || notifyDaily == true"><br /><strong>Please select a Notification Method under the General Tab to enable this screen.</strong></p>
                <v-flex style="overflow: hidden !important;" lg4 v-show="fncCheckMethodList('sms') && notifyDaily == false">
                  <label class="blackLabel">Usable Shortcodes:</label>

                  <div class="shortcodes">
                    <h3 style="font-size:12px !important;">Originator Details</h3>
                    <div title="Add the Sales Rep's first name to the message" @click="fncSetShortcodeSms('[REP_NAME]', 'rep')">[REP_NAME]</div>
                    <div title="Add the Sales Rep's surname to the message" @click="fncSetShortcodeSms('[REP_SURNAME]', 'rep')">[REP_SURNAME]</div>
                    <div title="Add the Sales Rep's email address to the message" @click="fncSetShortcodeSms('[REP_EMAIL]', 'rep')">[REP_EMAIL]</div>
                    <div title="Add the Sales Rep's telephone number to the message" @click="fncSetShortcodeSms('[REP_TEL]', 'rep')">[REP_TEL]</div>
                    <div title="Add your business name to the message" @click="fncSetShortcodeSms('[YOUR_COMPANY_NAME]', 'rep')">[YOUR_COMPANY_NAME]</div>
                  </div>

                  <div class="shortcodes">
                    <h3 style="font-size:12px !important;">Customer Details</h3>
                    <div title="Add the Customer's first name to the message" @click="fncSetShortcodeSms('[CUSTOMER_NAME]', 'rep')">[CUSTOMER_NAME]</div>
                    <div title="Add the Customer's surname to the message" @click="fncSetShortcodeSms('[CUSTOMER_SURNAME]', 'rep')">[CUSTOMER_SURNAME]</div>
                    <div title="Add the Customer's email address to the message" @click="fncSetShortcodeSms('[CUSTOMER_EMAIL]', 'rep')">[CUSTOMER_EMAIL]</div>
                    <div title="Add the Customer's telephone number to the message" @click="fncSetShortcodeSms('[CUSTOMER_TEL]', 'rep')">[CUSTOMER_TEL]</div>
                    <div title="Add the Customer's company to the message" @click="fncSetShortcodeSms('[CUSTOMER_COMPANY]', 'rep')">[CUSTOMER_COMPANY]</div>
                    <div title="Add the Customer's Delivery Details to the message" @click="fncSetShortcode('[CUSTOMER_DELIVERY_DETAILS]', 'rep')">[CUSTOMER_DELIVERY_DETAILS]</div>
                  </div>

                  <div class="shortcodes">
                    <h3 style="font-size:12px !important;margin-top: 20px !important;">Recipient Details</h3>
                    <div :title="fncRecName()" @click="fncSetShortcodeSms('[RECIPIENT_NAME]', 'rep')">[RECIPIENT_NAME]</div>
                    <div :title="fncRecSurname()" @click="fncSetShortcodeSms('[RECIPIENT_SURNAME]', 'rep')">[RECIPIENT_SURNAME]</div>
                    <div :title="fncRecEmail()" @click="fncSetShortcodeSms('[RECIPIENT_EMAIL]', 'rep')">[RECIPIENT_EMAIL]</div>
                  </div>

                  <div class="shortcodes">
                    <h3 style="font-size:12px !important;margin-top: 20px !important;">Quote Details</h3>
                    <div title="Add the quote date to the message" @click="fncSetShortcodeSms('[QUOTE_DATE]', 'rep')">[QUOTE_DATE]</div>
                    <div title="Add the quote number to the message" @click="fncSetShortcodeSms('[QUOTE_NO]', 'rep')">[QUOTE_NO]</div>
                    <div title="Add the current quote status to the message" @click="fncSetShortcodeSms('[QUOTE_STATUS]', 'rep')">[QUOTE_STATUS]</div>
                    <div title="Add the quote vat total to the message" @click="fncSetShortcodeSms('[QUOTE_TOTAL_VATEXCL]', 'rep')">[QUOTE_TOTAL_VATEXCL]</div>
                    <div title="Add the quote total including vat to the message" @click="fncSetShortcodeSms('[QUOTE_TOTAL_VATINCL]', 'rep')">[QUOTE_TOTAL_VATINCL]</div>
                    <div title="Add Quote Memo" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_MEMO]', 'rep')">[QUOTE_MEMO]</div>
                    <div title="Add Quote External Ref" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_EXTERNAL_REF]', 'rep')">[QUOTE_EXTERNAL_REF]</div>
                    <div title="Add Quote PDF Download Button" v-if="notifyDaily === false" @click="fncSetShortcode('[DOWNLOAD_BUTTON]', 'rep')">[DOWNLOAD_BUTTON]</div>
                  </div>
                </v-flex>
                <v-flex lg8 v-if="fncCheckMethodList('sms') && notifyDaily == false && this.internalSmsPreview == false">              
                  <label class="blackLabel">* Create Whatsapp Message:</label><br />                
                  <label>Select Whatsapp Template</label>
                  <v-select class="shortSelect" placeholder="Select Whatsapp Template" @change="fncDisplayTemplate('internal', $event)" v-model="notificationWhatsappTemplate" :items="whatsappTemplates" item-text="name" item-value="id" solo outline></v-select><br />

                  <p v-show="hideInternalTemplate == true"><strong>Saved TWILIO Template:<br /></strong>{{ templateMessageInternal }}</p>
                  <div v-show="hideInternalTemplate == true" id="templateMessageInternalHolder" v-html="fncSetTwilioTemplate()"></div>

                  <label v-show="hideInternalTemplate == false">Whatsapp Message</label>
                  <v-text-field v-show="hideInternalTemplate == false" id="repSmsText" @focus="fncDisablePaste()" placeholder="Create Whatsapp Message" v-model="notificationSmsMessage" single-line solo></v-text-field>

                </v-flex>
                <v-flex lg8 v-if="fncCheckMethodList('sms') && notifyDaily == false && this.internalSmsPreview == true">
                  <label class="blackLabel">* Whatsapp Message:</label>
                  <small><span style="display: block !important; float:left !important;">Message that will be sent to the rep </span> <span style="font-weight:bold;cursor:pointer;text-decoration:underline;display:block !important; float: left !important;margin-left: 5px !important;" @click.prevent="fncShowInternalSmsPreview(false)">HIDE PREVIEW</span></small>
                  <div v-html="fncContentInternalSms()"></div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="4">
            <v-container grid-list-xl style="padding-top: 0px !important;">
              <v-layout row wrap>
                <p v-show="!fncCheckMethodList('email') || notifyCustomer == false || notifyDaily == true"><br /><strong>Please select a Notification Method under the General Tab to enable this screen.</strong></p>
                <v-flex lg4 style="overflow: hidden !important;" v-show="notifyCustomer == true && fncCheckMethodList('email')">
                  <v-switch class="switchSmall" label="Attach the quote PDF" style="margin-top: 0px;height:46px;" v-model="notifyAddPdfCustomer"></v-switch>
                  <v-switch class="switchSmall" v-if="objAuthorize.so_template != ''" label="Attach the Sales Order PDF" style="margin-top: -20px;" v-model="notifyAddPdfSoCustomer"></v-switch>
                  <label class="blackLabel" style="margin-top: 15px !important;">Usable Shortcodes:</label>
                  <div class="shortcodes">
                    <h3 style="font-size:12px !important;">Originator Details</h3>
                    <div title="Add the Sales Rep's first name to the message" @click="fncSetShortcode('[REP_NAME]', 'customer')">[REP_NAME]</div>
                    <div title="Add the Sales Rep's surname to the message" @click="fncSetShortcode('[REP_SURNAME]', 'customer')">[REP_SURNAME]</div>
                    <div title="Add the Sales Rep's email address to the message" @click="fncSetShortcode('[REP_EMAIL]', 'customer')">[REP_EMAIL]</div>
                    <div title="Add the Sales Rep's telephone number to the message" @click="fncSetShortcode('[REP_TEL]', 'customer')">[REP_TEL]</div>
                    <div title="Add your business name to the message" @click="fncSetShortcode('[YOUR_COMPANY_NAME]', 'customer')">[YOUR_COMPANY_NAME]</div>
                    <h3 style="font-size:12px !important;margin-top: 20px !important;">Quote Details</h3>
                    <div title="Add the quote date to the message" @click="fncSetShortcode('[QUOTE_DATE]', 'customer')">[QUOTE_DATE]</div>
                    <div title="Add the quote number to the message" @click="fncSetShortcode('[QUOTE_NO]', 'customer')">[QUOTE_NO]</div>
                    <div title="Add the current quote status to the message" @click="fncSetShortcode('[QUOTE_STATUS]', 'customer')">[QUOTE_STATUS]</div>
                    <div title="Add a summary of the quote to the message" @click="fncSetShortcode('[QUOTE_SUMMARY]', 'customer')">[QUOTE_SUMMARY]</div>
                    <div title="Add the quote total Exclusive to the message" @click="fncSetShortcode('[QUOTE_TOTAL_VATEXCL]', 'customer')">[QUOTE_TOTAL_VATEXCL]</div>
                    <div title="Add the quote total including vat to the message" @click="fncSetShortcode('[QUOTE_TOTAL_VATINCL]', 'customer')">[QUOTE_TOTAL_VATINCL]</div>
                    <div title="Add buttons for the customer to Accept/Reject a quote to the message" @click="fncSetShortcode('[QUOTE_ACCEPT_REJECT]', 'customer')">[QUOTE_ACCEPT_REJECT]</div>
                    <!--<div title="Add buttons for the customer to Final Accept/Reject a quote to the message" @click="fncSetShortcode('[QUOTE_ACCEPT_REJECT_FINAL]', 'customer')">[QUOTE_ACCEPT_REJECT_FINAL]</div>-->
                    <div title="Add the Transaction ID" @click="fncSetShortcode('[TRANSACTION_ID]', 'customer')">[TRANSACTION_ID]</div>
                    <div title="Add the Shipping Tracking Number" @click="fncSetShortcode('[SHIPPING_TRACKING_NO]', 'customer')">[SHIPPING_TRACKING_NO]</div>
                    <div title="Add the Shipping Tracking Url" @click="fncSetShortcode('[SHIPPING_TRACKING_URL]', 'customer')">[SHIPPING_TRACKING_URL]</div>
                    <div title="Add the Shipping Date / Time" @click="fncSetShortcode('[SHIPPING_DATE_TIME]', 'customer')">[SHIPPING_DATE_TIME]</div>
                  </div>
                  <div class="shortcodes">
                    <h3 style="font-size:12px !important;">Customer Details</h3>
                    <div title="Add the Customer's first name to the message" @click="fncSetShortcode('[CUSTOMER_NAME]', 'customer')">[CUSTOMER_NAME]</div>
                    <div title="Add the Customer's surname to the message" @click="fncSetShortcode('[CUSTOMER_SURNAME]', 'customer')">[CUSTOMER_SURNAME]</div>
                    <div title="Add the Customer's email address to the message" @click="fncSetShortcode('[CUSTOMER_EMAIL]', 'customer')">[CUSTOMER_EMAIL]</div>
                    <div title="Add the Customer's telephone number to the message" @click="fncSetShortcode('[CUSTOMER_TEL]', 'customer')">[CUSTOMER_TEL]</div>
                    <div title="Add the Customer's company to the message" @click="fncSetShortcode('[CUSTOMER_COMPANY]', 'customer')">[CUSTOMER_COMPANY]</div>
                    <div title="Add the Customer's Delivery Details to the message" @click="fncSetShortcode('[CUSTOMER_DELIVERY_DETAILS]', 'customer')">[CUSTOMER_DELIVERY_DETAILS]</div>
                    <div title="Add the Customer Recipient to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_CUSTOMER_RECIPIENT]', 'customer')">[QUOTE_CUSTOMER_RECIPIENT]</div>
                    <h3 style="font-size:12px !important;margin-top: 20px !important;">Quote Details</h3>
                    <div title="Add the commercial kam" @click="fncSetShortcode('[QUOTE_COMMERCIAL_KAM]', 'customer')">[QUOTE_COMMERCIAL_KAM]</div>
                    <div title="Add the commercial kam" @click="fncSetShortcode('[QUOTE_COMMERCIAL_COORDINATOR]', 'customer')">[QUOTE_COMMERCIAL_COORDINATOR]</div>
                    <div title="Add the sales order number" @click="fncSetShortcode('[SALES_ORDER_NUMBER]', 'customer')">[SALES_ORDER_NUMBER]</div>
                    <div title="Add the Service Form type" @click="fncSetShortcode('[SERVICE_TYPE]', 'customer')">[SERVICE_TYPE]</div>
                    <div title="Add the sales order number to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_SO_NUMBER]', 'customer')">[QUOTE_SO_NUMBER]</div>
                    <div title="Add the purchase order number to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_PO_NUMBER]', 'customer')">[QUOTE_PO_NUMBER]</div>
                    <div title="Add the store to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_STORE]', 'customer')">[QUOTE_STORE]</div>
                    <div title="Add the status reason to the message" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_STATUS_REASON]', 'customer')">[QUOTE_STATUS_REASON]</div>
                    <div title="Add the time the status has not changed" v-if="notifyDaily === false" @click="fncSetShortcode('[QUOTE_TIME_IN_STATUS]', 'customer')">[QUOTE_TIME_IN_STATUS]</div>
                    <div title="Add the Company" v-if="notifyDaily === false" @click="fncSetShortcode('[COMPANY]', 'customer')">[COMPANY]</div>
                    <div title="Add the Project" v-if="notifyDaily === false" @click="fncSetShortcode('[PROJECT]', 'customer')">[PROJECT]</div>
                    <div title="Add the Department" v-if="notifyDaily === false" @click="fncSetShortcode('[DEPARTMENT]', 'customer')">[DEPARTMENT]</div>
                  </div>
                </v-flex>
                <v-flex lg6 v-if="notifyCustomer == true && fncCheckMethodList('email') && this.customerEmailPreview == false">
                  <label style="display: block;float:left; width:10% !important;padding-top: 10px;" class="blackLabel">* Subject:</label>
                  <v-text-field placeholder="Subject" style="display: block;float:left; width:45% !important;" v-model="notificationCustomerSubject" single-line solo></v-text-field>
                  <small style="display: block;float:left; width:30% !important;padding-top: 12px !important;">&nbsp;&nbsp;Subject line of the Email</small>
                  <div style="clear:both;"></div>
                  <label class="blackLabel" style="margin-top: 20px !important;">* Create Message Text:</label>
                  <small>Set up the message that will be sent to the Customer.  Insert the shortcode variables into your message template by clicking on them from the desired part of your text. <span style="font-weight:bold;cursor:pointer;text-decoration:underline;" @click.stop="fncShowCustomerEmailPreview(true)">VIEW EXAMPLE</span></small>
                  <v-text-field v-if="objAuthorize.privileges.indexOf('CAN_PASTE_NOTIFICATIONS') == -1" rows="10" @focus="fncDisablePaste()" placeholder="Customer Email Text" id="customerText" v-model="customerWysiwig" multi-line solo></v-text-field>
                  <v-text-field v-if="objAuthorize.privileges.indexOf('CAN_PASTE_NOTIFICATIONS') != -1" rows="10" placeholder="Customer Email Text" id="customerText" v-model="customerWysiwig" multi-line solo></v-text-field>
                </v-flex>
                <v-flex lg6 v-if="notifyCustomer == true && fncCheckMethodList('email') && this.customerEmailPreview == true">
                  <label class="blackLabel">* Message:</label>
                  <small><span style="display: block !important; float: left !important;">Message that will be sent to the customer</span> <span style="font-weight:bold;cursor:pointer;text-decoration:underline;display: block !important; float: left !important;margin-left: 5px !important;" @click.stop="fncShowCustomerEmailPreview(false)">HIDE PREVIEW</span></small>
                  <div style="white-space: pre-line !important;" v-html="fncContentCustomerEmail()"></div>
                </v-flex>
                <v-flex lg2>
                  <h3 style="font-size:12px !important;margin-top: 0px !important;">Add Attachment Categories</h3>
                  <v-select :items="attachmentCategories" placeholder="Notification Attachment Categories" class="dropdown" v-model="notificationUserCats" item-value="id" item-text="name" multiple outline></v-select>
                  <h3 style="font-size:12px !important;margin-top: 00px !important;">Add Roles Shortcode</h3>
                  <v-select :items="userRoles" placeholder="Notification User Roles" @input="fncSetRoleUser" v-model="shortRoleUser" class="dropdown" item-value="id" item-text="name" solo></v-select>
                  <!--<br /><h3 style="font-size:12px !important;margin-top: 00px !important;">Add Status Button</h3>
                  <v-select :items="statusList" placeholder="Notification Status Button" @input="fncSetStatusUser" v-model="shortStatusUser" class="dropdown" item-value="id" item-text="description" solo></v-select>
                  <br />-->
                  <v-switch class="switchSmall pdfSwitch"  v-if="notifyDaily === false" label="Attach the full service form" style="margin-top: 0px;" v-model="attachServiceFormFullCustomer"></v-switch>
                  <v-switch class="switchSmall pdfSwitch"  v-if="notifyDaily === false" label="Attach the customer service form" style="margin-top: 0px;" v-model="attachServiceFormClientCustomer"></v-switch>
                  <v-switch class="switchSmall pdfSwitch"  v-if="notifyDaily === false" label="Attach Delivery Note" style="margin-top: 0px;" v-model="attachDeliveryNoteCustomer"></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="5">
            <v-container grid-list-xl style="padding-top: 0px !important;">
              <v-layout row wrap>
                <p v-show="!fncCheckMethodList('sms') || notifyCustomer == false || notifyDaily == true"><br /><strong>Please select a Notification Method under the General Tab to enable this screen.</strong></p>
                <v-flex lg4 style="overflow: hidden !important;" v-show="notifyCustomer == true && fncCheckMethodList('sms')">
                  <label class="blackLabel">Usable Shortcodes:</label>
                  <div class="shortcodes">
                    <h3 style="font-size:12px !important;">Originator Details</h3>
                    <div title="Add the Sales Rep's first name to the message" @click="fncSetShortcodeSms('[REP_NAME]', 'customer')">[REP_NAME]</div>
                    <div title="Add the Sales Rep's surname to the message" @click="fncSetShortcodeSms('[REP_SURNAME]', 'customer')">[REP_SURNAME]</div>
                    <div title="Add the Sales Rep's email address to the message" @click="fncSetShortcodeSms('[REP_EMAIL]', 'customer')">[REP_EMAIL]</div>
                    <div title="Add the Sales Rep's telephone number to the message" @click="fncSetShortcodeSms('[REP_TEL]', 'customer')">[REP_TEL]</div>
                    <div title="Add your business name to the message" @click="fncSetShortcodeSms('[YOUR_COMPANY_NAME]', 'customer')">[YOUR_COMPANY_NAME]</div>
                  </div>
                  <div class="shortcodes">
                    <h3 style="font-size:12px !important;">Customer Details</h3>
                    <div title="Add the Customer's first name to the message" @click="fncSetShortcodeSms('[CUSTOMER_NAME]', 'customer')">[CUSTOMER_NAME]</div>
                    <div title="Add the Customer's surname to the message" @click="fncSetShortcodeSms('[CUSTOMER_SURNAME]', 'customer')">[CUSTOMER_SURNAME]</div>
                    <div title="Add the Customer's email address to the message" @click="fncSetShortcodeSms('[CUSTOMER_EMAIL]', 'customer')">[CUSTOMER_EMAIL]</div>
                    <div title="Add the Customer's telephone number to the message" @click="fncSetShortcodeSms('[CUSTOMER_TEL]', 'customer')">[CUSTOMER_TEL]</div>
                    <div title="Add the Customer's company to the message" @click="fncSetShortcodeSms('[CUSTOMER_COMPANY]', 'customer')">[CUSTOMER_COMPANY]</div>
                  </div>
                  <div class="shortcodes">
                    <h3 style="font-size:12px !important;margin-top: 20px !important;">Quote Details</h3>
                    <div title="Add the quote date to the message" @click="fncSetShortcodeSms('[QUOTE_DATE]', 'customer')">[QUOTE_DATE]</div>
                    <div title="Add the quote number to the message" @click="fncSetShortcodeSms('[QUOTE_NO]', 'customer')">[QUOTE_NO]</div>
                    <div title="Add the current quote status to the message" @click="fncSetShortcodeSms('[QUOTE_STATUS]', 'customer')">[QUOTE_STATUS]</div>
                    <div title="Add the quote total Exclusive to the message" @click="fncSetShortcodeSms('[QUOTE_TOTAL_VATEXCL]', 'customer')">[QUOTE_TOTAL_VATEXCL]</div>
                    <div title="Add the quote vat total to the message" @click="fncSetShortcodeSms('[QUOTE_TOTAL_VATINCL]', 'customer')">[QUOTE_TOTAL_VATINCL]</div>
                    <div title="Add Quote PDF Download Button" v-if="notifyDaily === false" @click="fncSetShortcodeSms('[DOWNLOAD_BUTTON]', 'customer')">[DOWNLOAD_BUTTON]</div>
                  </div>
                </v-flex>
                <v-flex lg8 v-if="notifyCustomer == true && fncCheckMethodList('sms') && this.customerSmsPreview == false">                
                  <label class="blackLabel">* Create Whatsapp Message:</label><br />                
                  <label>Select Whatsapp Template</label>
                  <v-select class="shortSelect" placeholder="Select Whatsapp Template" @change="fncDisplayTemplate('customer', $event)" v-model="notificationWhatsappTemplateCustomer" :items="whatsappTemplates" item-text="name" item-value="id" solo outline></v-select><br />

                  <p v-show="hideCustomerTemplate == true"><strong>Saved TWILIO Template:<br /></strong>{{ templateMessageCustomer }}</p>
                  <div v-show="hideCustomerTemplate == true" id="templateMessageCustomerHolder" v-html="fncSetTwilioTemplateCustomer()"></div>

                  <label v-show="hideCustomerTemplate == false">Whatsapp Message</label>
                  <v-text-field v-show="hideCustomerTemplate == false" @focus="fncDisablePaste()" id="customerSmsText" placeholder="Create Whatsapp Message" v-model="notificationCustomerSmsMessage" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg8 v-if="notifyCustomer == true && fncCheckMethodList('sms') && this.customerSmsPreview == true">
                  <label class="blackLabel">* SMS Message:</label>
                  <small><span style="display: block !important; float:left !important;">Message that will be sent to the customer </span> <span style="font-weight:bold;cursor:pointer;text-decoration:underline;display:block !important; float: left !important;margin-left: 5px !important;" @click.prevent="fncShowCustomerSmsPreview(false)">HIDE PREVIEW</span></small>
                  <div v-html="fncContentCustomerSms()"></div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="6">
            <v-container grid-list-xl style="padding-top: 0px !important;">
              <v-layout row wrap>
                <v-flex lg3>
                  <label class="blackLabel">API Auth Token:</label>
                  <small>Does this API call need an Autorization token?</small>
                  <v-switch v-model="apiData.apiAuth"></v-switch>
                </v-flex>
                <v-flex lg3>
                  <div v-if="apiData.apiAuth == true || apiData.apiAuth == 'true'">
                    <label class="blackLabel">API Auth Variable Type:</label>
                    <small>What kind of variables does the auth token receive?</small>
                    <v-select :items="apiAuthDataTypes" placeholder="Auth Data Type" class="dropdown" v-model="apiData.apiAuthDataType" item-value="id" item-text="name" solo></v-select>
                  </div>
                </v-flex>
                <v-flex lg3>
                  <div v-if="apiData.apiAuth == true || apiData.apiAuth == 'true'">
                    <label class="blackLabel">API Auth URL:</label>
                    <small>URL for the api auth?</small>
                    <v-text-field v-model="apiData.apiAuthUrl" placeholder="URL for Auth Call" solo></v-text-field>
                  </div>
                </v-flex>
                <v-flex lg3>
                  <div v-if="apiData.apiAuth == true || apiData.apiAuth == 'true'">
                    <label class="blackLabel">API Auth Variables:</label>
                    <small>If JSON paste JSON, else comma deliminated list like id: value, id: value</small>
                    <v-text-field rows="5" v-model="apiData.apiAuthData" placeholder="JSON for Auth Call" multi-line solo></v-text-field>
                  </div>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">API Variable Type:</label>
                  <small>What kind of variables does the auth token receive?</small>
                  <v-select :items="apiDataTypes" placeholder="Auth Data Type" class="dropdown" v-model="apiData.apiDataType" item-value="id" item-text="name" solo></v-select>
                </v-flex>
                <v-flex lg3>
                    <label class="blackLabel">API URL:</label>
                    <small>URL for the api?</small>
                    <v-text-field v-model="apiData.apiUrl" placeholder="URL for Auth Call" solo></v-text-field>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">API Variables:</label>
                  <small>If JSON paste JSON, else comma deliminated list like id: value, id: value</small>
                  <v-text-field rows="5" v-model="apiData.apiData" placeholder="JSON for Auth Call" multi-line solo></v-text-field>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Usable Shortcodes:</label>
                  <small>Please copy and paste</small><br />
                  <span style="font-size: 10px;font-weight: bold;">[AUTH_TOKEN]</span><br />
                  <span style="font-size: 10px;font-weight: bold;">[QUOTE_NO]</span><br />
                  <span style="font-size: 10px;font-weight: bold;">[QUOTE_ID]</span>
                </v-flex>
                <!--<p v-show="!fncCheckMethodList('sms') || notifyCustomer == false || notifyDaily == true"><br /><strong>Please select a Notification Method under the General Tab to enable this screen.</strong></p>
                <v-flex lg4 style="overflow: hidden !important;" v-show="notifyCustomer == true && fncCheckMethodList('sms')">
                  <label class="blackLabel">Usable Shortcodes:</label>
                  <div class="shortcodes">
                    <h3 style="font-size:12px !important;">Rep Details</h3>
                    <div title="Add the Sales Rep's first name to the message" @click="fncSetShortcodeSms('[REP_NAME]', 'customer')">[REP_NAME]</div>
                    <div title="Add the Sales Rep's surname to the message" @click="fncSetShortcodeSms('[REP_SURNAME]', 'customer')">[REP_SURNAME]</div>
                    <div title="Add the Sales Rep's email address to the message" @click="fncSetShortcodeSms('[REP_EMAIL]', 'customer')">[REP_EMAIL]</div>
                    <div title="Add the Sales Rep's telephone number to the message" @click="fncSetShortcodeSms('[REP_TEL]', 'customer')">[REP_TEL]</div>
                    <div title="Add your business name to the message" @click="fncSetShortcodeSms('[YOUR_COMPANY_NAME]', 'customer')">[YOUR_COMPANY_NAME]</div>
                  </div>
                  <div class="shortcodes">
                    <h3 style="font-size:12px !important;">Customer Details</h3>
                    <div title="Add the Customer's first name to the message" @click="fncSetShortcodeSms('[CUSTOMER_NAME]', 'customer')">[CUSTOMER_NAME]</div>
                    <div title="Add the Customer's surname to the message" @click="fncSetShortcodeSms('[CUSTOMER_SURNAME]', 'customer')">[CUSTOMER_SURNAME]</div>
                    <div title="Add the Customer's email address to the message" @click="fncSetShortcodeSms('[CUSTOMER_EMAIL]', 'customer')">[CUSTOMER_EMAIL]</div>
                    <div title="Add the Customer's telephone number to the message" @click="fncSetShortcodeSms('[CUSTOMER_TEL]', 'customer')">[CUSTOMER_TEL]</div>
                    <div title="Add the Customer's company to the message" @click="fncSetShortcodeSms('[CUSTOMER_COMPANY]', 'customer')">[CUSTOMER_COMPANY]</div>
                  </div>
                  <div class="shortcodes">
                    <h3 style="font-size:12px !important;margin-top: 20px !important;">Quote Details</h3>
                    <div title="Add the quote date to the message" @click="fncSetShortcodeSms('[QUOTE_DATE]', 'customer')">[QUOTE_DATE]</div>
                    <div title="Add the quote number to the message" @click="fncSetShortcodeSms('[QUOTE_NO]', 'customer')">[QUOTE_NO]</div>
                    <div title="Add the current quote status to the message" @click="fncSetShortcodeSms('[QUOTE_STATUS]', 'customer')">[QUOTE_STATUS]</div>
                    <div title="Add the quote total Exclusive to the message" @click="fncSetShortcodeSms('[QUOTE_TOTAL_VATEXCL]', 'customer')">[QUOTE_TOTAL_VATEXCL]</div>
                    <div title="Add the quote vat total to the message" @click="fncSetShortcodeSms('[QUOTE_TOTAL_VATINCL]', 'customer')">[QUOTE_TOTAL_VATINCL]</div>
                  </div>
                </v-flex>
                <v-flex lg8 v-if="notifyCustomer == true && fncCheckMethodList('sms') && this.customerSmsPreview == false">
                  <label class="blackLabel">* Create SMS Message:</label>
                  <small>Message that will be sent to the customer <span style="font-weight:bold;cursor:pointer;text-decoration:underline;" @click.prevent="fncShowCustomerSmsPreview(true)">PREVIEW</span></small>
                  <v-text-field @focus="fncDisablePaste()" id="customerSmsText" placeholder="SMS Message" v-model="notificationCustomerSmsMessage" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg8 v-if="notifyCustomer == true && fncCheckMethodList('sms') && this.customerSmsPreview == true">
                  <label class="blackLabel">* SMS Message:</label>
                  <small><span style="display: block !important; float:left !important;">Message that will be sent to the customer </span> <span style="font-weight:bold;cursor:pointer;text-decoration:underline;display:block !important; float: left !important;margin-left: 5px !important;" @click.prevent="fncShowCustomerSmsPreview(false)">HIDE PREVIEW</span></small>
                  <div v-html="fncContentCustomerSms()"></div>
                </v-flex>-->
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs>
        <div class="pl-4 pr-1 pb-4 buttonHolder">
          <div style="float: right">
            <v-btn color="success" v-html="fncCloseButtonText()" class="text-xs-right cancelButton" @click.stop="fncHideModal"></v-btn>
            <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
            <!--<v-btn color="success" class="text-xs-right" @click.stop="fncSaveNotifications()" :disabled="canSave == false">Save</v-btn>
            <small>* The button will activate once an update has been made</small>-->
          </div>
        </div>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';

  import Vue from 'vue'
  import Vuex from 'vuex'
  import Vueditor, { createEditor } from 'vueditor'

  import 'vueditor/dist/style/vueditor.min.css'

  Vue.use(Vuex);

  export default {
    name: 'Settings',
    data () {
      return {
        allBranches: false,
        allDepartments: false,
        repCursor: 0,
        isAddValid: false,
        canSave: false,
        search: '',
        filteredUserTypes: [],
        filteredUserTypesVendors: [],
        viewList: true,
        notificationFormKey: 0,
        notificationCats: [],
        notificationUserCats: [],
        notificationHeader: [
          { text: 'Name', value: 'name', width: '35%' },
          { text: 'Department', value: 'name', width: '10%' },
          { text: 'Type', value: 'updated', width: '20%' },
          { text: 'Edit', value: 'edit', width: '10%' },
          { text: 'Delete', value: 'delete', width: '10%' },
          { text: 'Deactivated / Active', value: 'delete', width: '15%' }
        ],
        notificationTypes: [
          { id: 1, name: 'On Change to this Status' },
          { id: 2, name: 'On lack of change from this status' },
          { id: 3, name: 'On lack of change from another status to this status' }
          //{ id: 3, name: 'Expiry' }
        ],
        notificationReportTypes: [
          { id: false, name: 'Send as trigger event occurs' },
          { id: true, name: 'Send summary at the end of the day' }
        ],
        quoteTypes: [
          { id: '', name: 'All' },
          { id: 'calculator', name: 'Calculator' },
          { id: 'serviceform', name: 'Service Form' }
        ],
        serviceTypes: [
          { id: '', name: 'All' },
          { id: 'self', name: 'Self Service' },
          { id: 'assisted', name: 'Assisted Service' },
          { id: 'commercial', name: 'Commercial' }
        ],
        notificationTimes: [
          { id: '00:00', name: '00:00 am' },
          { id: '02:00', name: '02:00 am' },
          { id: '04:00', name: '04:00 am' },
          { id: '06:00', name: '06:00 am' },
          { id: '08:00', name: '08:00 am' },
          { id: '10:00', name: '10:00 am' },
          { id: '12:00', name: '12:00 pm' },
          { id: '14:00', name: '14:00 pm' },
          { id: '16:00', name: '16:00 pm' },
          { id: '18:00', name: '18:00 pm' },
          { id: '20:00', name: '20:00 pm' },
          { id: '22:00', name: '22:00 pm' }
        ],
        notificationMethods: [
          { id: 'email', name: 'Email' },
          { id: 'sms', name: 'Whatsapp' },
        ],
        notificationSendDaysItems: [
          { id: '0', name: 'All Days' },        
          { id: '1', name: 'Monday' },
          { id: '2', name: 'Tuesday' },
          { id: '3', name: 'Wednesday' },
          { id: '4', name: 'Thursday' },
          { id: '5', name: 'Friday' },
          { id: '6', name: 'Saturday' },
          { id: '7', name: 'Sunday' }
        ],
        notificationSendDays: ["0","1","2","3","4","5","6","7"],
        notificationId: '',
        notificationName: '',
        notificationRole: [],
        notificationRoleIgnore: [],
        notificationType: '',
        notificationQuoteType: '',
        notificationServiceType: '',
        notificationYears: 0,
        notificationHours: 0,
        notificationDays: 0,
        notificationvalue: '',
        notificationMethod: [],
        notificationMessage: '',
        notifyCustomer: false,
        notifyVendor: false,
        notifyOriginator: false,
        isCallout: false,
        notifyKam: false,
        notifyCoordinator: false,
        notifyRep: false,
        notifyIsStore: false,
        notifyDaily: false,
        notifyStatusStatus: 0,
        notifyStatusDays: 0,
        notifyStatusHours: 0,
        notificationTime: '',
        notificationValue: 0,
        notificationAge: 30,
        notificationDirectReport: [],
        notificationSubject: '',
        notificationCustomerMessage: '',
        notificationCustomerSubject: '',
        notificationSmsMessage: '',
        notificationWhatsappTemplate: '',
        notificationWhatsappTemplateCustomer: '',
        notificationCustomerSmsMessage: '',
        repWysiwig: '',
        customerWysiwig: '',
        internalEmailPreview: false,
        internalSmsPreview: false,
        customerEmailPreview: false,
        customerSmsPreview: false,
        notifyAddPdf: false,
        attachServiceFormFull: false,
        attachServiceFormClient: false,
        attachServiceFormFullCustomer: false,
        attachServiceFormClientCustomer: false,
        notifyAddPoPdfVendor: false,
        notifyAddPdfCustomer: false,
        notifyAddPdfSoCustomer: false,
        vendorType: [],
        hasVendorRole: false,
        notificationVendors: [],
        notificationBranches: [],
        notificationReportVendors: [],
        notificationDepartments: [],
        apiData: {
          isApi: false,
          apiAuth: false,
          apiAuthUrl: '',
          apiAuthDataType: '',
          apiDataType: '',
          apiAuthData: '',
          apiData: '',
          apiUrl: ''
        },
        apiAuthDataTypes: [
          { id: 'json', name: 'JSON' },
          { id: 'variables', name: 'Variables' }
        ],
        apiDataTypes: [
          { id: 'json', name: 'JSON' },
          { id: 'variables', name: 'Variables' }
        ],
        departmentListSet: [],
        shortRole: 0,
        shortRoleUser: 0,
        shortStatus: 0,
        shortStatusUser: 0,
        subDepartmentFilter: window.localStorage.notificationSubDepartment != undefined && window.localStorage.notificationSubDepartment != null ? parseInt(window.localStorage.notificationSubDepartment) : 0,
        //subDepartmentFilter: 0,
        notificationListSet: [],
        notificationDepartmentList: [],
        attachDeliveryNote: false,
        attachDeliveryNoteCustomer: false,
        hideInternalTemplate: true,
        hideCustomerTemplate: true,
        templateMessageInternal: '',
        templateMessageCustomer: ''
      };
    },
    methods: {
      fncTemplateInputValue(value) {
        value = value == undefined || value == null ? '' : value.toString();
        return value
          .replace(/&/g, '&amp;')
          .replace(/"/g, '&quot;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
      },
      fncBuildTwilioTemplateInputs(template, savedMessage) {
        let html = '';
        let savedVariables = {};
        template = template == undefined || template == null ? '' : template.toString();
        savedMessage = savedMessage == undefined || savedMessage == null ? '' : savedMessage.toString();

        if( savedMessage != '' && savedMessage.includes('{') ) {
          try {
            savedVariables = JSON.parse(savedMessage);
          } catch(e) {
            savedVariables = {};
          }
        }

        let matches = template.match(/\{\{(\d+)\}\}/g);

        if (matches) {
          matches.forEach(m => {
            let num = m.replace(/[{}]/g, '');
            let value = this.fncTemplateInputValue(savedVariables[num]);
            html += `{{${num}}} : <input type="text" style="border: 1px solid #EFEFEF;" value="${value}" data-var="${num}" /><br>`;
          });
        }

        return html;
      },
      fncCollectTwilioTemplateVariables(holder, template) {
        let variables = {};

        document.querySelectorAll('#' + holder + ' input').forEach(input => {
          let key = input.dataset.var;
          variables[key] = input.value;
        });

        variables['template'] = template;

        return JSON.stringify(variables);
      },
      fncSetTwilioTemplate() {

        let html = '';  

        if( this.notificationWhatsappTemplate != '' && this.notificationWhatsappTemplate != '0' ) {
                    
          for( var t in this.whatsappTemplates ) {
            if( this.whatsappTemplates[t].id == this.notificationWhatsappTemplate ) {
               this.templateMessageInternal = this.whatsappTemplates[t].text; 
            }
          }

          this.hideInternalTemplate = true;
          html = this.fncBuildTwilioTemplateInputs(this.templateMessageInternal, this.notificationSmsMessage);
          
          
        } else {

          this.hideInternalTemplate = false;

        }

        return html;

      },
      fncSetTwilioTemplateCustomer() {

        let html = '';

        if( this.notificationWhatsappTemplateCustomer != '' && this.notificationWhatsappTemplateCustomer != '0' ) {

          for( var t in this.whatsappTemplates ) {
            if( this.whatsappTemplates[t].id == this.notificationWhatsappTemplateCustomer ) {
              this.templateMessageCustomer = this.whatsappTemplates[t].text;
            }
          }

          this.hideCustomerTemplate = true;
          html = this.fncBuildTwilioTemplateInputs(this.templateMessageCustomer, this.notificationCustomerSmsMessage);

        } else {

          this.hideCustomerTemplate = false;

        }

        return html;

      },
      fncDisplayTemplate( type, id ) {

          if( id != undefined && id != null && typeof id == 'object' ) {
            id = id.id;
          }

          if( id == undefined || id == null || id == '' ) {
            id = type == 'internal' ? this.notificationWhatsappTemplate : this.notificationWhatsappTemplateCustomer;
          }

          const index = this.whatsappTemplates.findIndex(t => t.id == id);
          
          if( id == 0 || index == -1 ) {
            if( type == 'internal' ) {
                this.notificationSmsMessage = '';
                this.hideInternalTemplate = false;        
                this.templateMessageInternal = '';
            } else {
                this.notificationCustomerSmsMessage = '';
                this.hideCustomerTemplate = false;
                this.templateMessageCustomer = '';
            }    
          } else {
            if( type == 'internal' ) {
              this.hideInternalTemplate = true;
              this.templateMessageInternal = this.whatsappTemplates[index].text;

              let template = this.whatsappTemplates[index].text;
              let html = this.fncBuildTwilioTemplateInputs(template, '');

              this.$nextTick(() => {
                let holder = document.getElementById("templateMessageInternalHolder");
                if( holder ) {
                  holder.innerHTML = html;
                }
              });

            } else {
              this.hideCustomerTemplate = true;
              this.templateMessageCustomer = this.whatsappTemplates[index].text;

              let template = this.whatsappTemplates[index].text;
              let html = this.fncBuildTwilioTemplateInputs(template, '');

              this.$nextTick(() => {
                let holder = document.getElementById("templateMessageCustomerHolder");
                if( holder ) {
                  holder.innerHTML = html;
                }
              });
            }
          }
          
      },
      fncFilterNotifications() {

        localStorage.setItem('notificationSubDepartment', this.subDepartmentFilter);

        this.globalModalParams.subFilter = '';

        if( this.subDepartmentFilter != '' && this.subDepartmentFilter != '0' ) {
          this.globalModalParams.subFilter = this.subDepartmentFilter
        }

        this.globalModalParams.hideModal = false;
        this.globalModalParams.id = this.globalModalParams.statusId;

        this.$store.dispatch('fncGetStatusNotifications', this.globalModalParams);

        // this.$store.dispatch('fncGetStatusNotifications', status);

        /*if( this.subDepartmentFilter != 0 ) {
          var newNotifications = [];
          for( var n in this.statusNotificationList ) {

            var departmentList = this.statusNotificationList[n].departments.split(',');

            if( departmentList.indexOf(String( this.subDepartmentFilter )) != -1 ) {
              newNotifications.push( this.statusNotificationList[n] );
            }

          }

          this.notificationListSet = newNotifications;
        } else {
          this.notificationListSet = this.statusNotificationList;
        }*/

      },
      fncSetStatusUser() {
        var statusLabel = '';
        for( var u in this.statusList ) {
          if( this.statusList[u].id == this.shortStatusUser ){
            statusLabel = this.statusList[u].description;
          }
        }
        if( statusLabel != '' ) {
          this.fncSetShortcode('[STATUS id="'+this.shortStatusUser+'" name="'+statusLabel.trim()+'"]', 'customer');
          this.shortStatusUser = 99999;
        }
        this.shortStatusUser = 99999;
      },
      fncSetStatus() {
        var statusLabel = '';
        for( var u in this.statusList ) {
          if( this.statusList[u].id == this.shortStatus ){
            statusLabel = this.statusList[u].description;
          }
        }
        if( statusLabel != '' ) {
          this.fncSetShortcode('[STATUS id="'+this.shortStatus+'" name="'+statusLabel.trim()+'"]', 'rep');
          this.shortStatus = 99999;
        }
        this.shortStatus = 99999;
      },
      fncSetRole() {
        var roleLabel = '';
        for( var u in this.userRoles ) {
          if( this.userRoles[u].id == this.shortRole ){
            roleLabel = this.userRoles[u].name;
          }
        }
        if( roleLabel != '' ) {
          this.fncSetShortcode('[ROLE id="'+this.shortRole+'" name="'+roleLabel+'"]', 'rep');
          this.shortRole = 99999;
        }
        this.shortRole = 99999;
      },
      fncSetRoleUser() {
        var roleLabel = '';
        for( var u in this.userRoles ) {
          if( this.userRoles[u].id == this.shortRoleUser ){
            roleLabel = this.userRoles[u].name;
          }
        }
        if( roleLabel != '' ) {
          this.fncSetShortcode('[ROLE id="'+this.shortRoleUser+'" name="'+roleLabel+'"]', 'customer');
          this.shortRoleUser = 99999;
        }
        this.shortRoleUser = 99999;
      },
      fncGetDepartment(department) {
        if( department != null ) {
          var departments = department.split( ',' );
        } else {
          departments = [];
        }
        if( department == 0 || departments.length == 0 ) {
          return 'N/A';
        } else {
          var toAdd = [];
          for( var d in this.departmentList ) {
            if( departments.indexOf( String(this.departmentList[d].id) ) != -1 ) {
              toAdd.push(this.departmentList[d].name);
            }
          }
          return toAdd.join('<br />');
        }
      },
      fncCheckBranches(e) {

        var lastClicked = this.notificationBranches[this.notificationBranches.length-1];

        if( this.notificationBranches.indexOf('0') != -1 || this.notificationBranches.indexOf(0) != -1 ) {

          if (lastClicked == 0) {

            this.notificationBranches = [];
            this.notificationBranches.push(0);

            for( var b in this.branchList ) {
              if( this.branchList[b].id != '0' ) {
                this.notificationBranches.push(this.branchList[b].id);
              }
            }

          } else {

            var unique = [...new Set(this.branchList .map(item => item.id))]; // [ 'A', 'B']
            var uniqueBranches = [...new Set(this.notificationBranches .map(item => item))]; // [ 'A', 'B']

            var moveZero = false;

            if( ( uniqueBranches.length ) == ( unique.length - 1 ) ) {
              for( var b in this.notificationBranches ) {
                if( this.notificationBranches[b] == '0' ) {
                  var index = this.notificationBranches.indexOf(this.notificationBranches[b]);
                  if (index !== -1) {
                    moveZero = true;
                  }
                }
              }
            }
          }

          if( moveZero == true ) {
            var newBranches = [];
            for( var b in this.notificationBranches ) {
              if( this.notificationBranches[b] != '0' ) {
                newBranches.push( this.notificationBranches[b]  );
              }
            }
            this.notificationBranches = newBranches;
          }
        } else {

          var unique = [...new Set(this.branchList .map(item => item.id))];
          var uniqueBranches = [...new Set(this.notificationBranches .map(item => item))];

          if( this.notificationBranches.length == ( unique.length - 1 ) ) {
            var index = this.notificationBranches.indexOf(0);
            if (index == -1) {
              this.notificationBranches = [];
            }
          }
        }

        /*var lastClicked = this.notificationBranches[this.notificationBranches.length-1];

        if( this.notificationBranches.indexOf('0') != -1 || this.notificationBranches.indexOf(0) != -1 ) {

          if( lastClicked == '0' | lastClicked == 0 ) {
            this.notificationBranches = [];
            this.notificationBranches.push(0);

            for( var b in this.branchList ) {
              this.notificationBranches.push(this.branchList[b].id);
            }
          } else {
            var newDepartments = [];
            for( var b in this.notificationBranches ) {
              if(this.notificationBranches[b] != '0' && this.notificationBranches[b] != 0) {
                newDepartments.push(this.notificationBranches[b]);
              }
            }
            this.notificationBranches = newDepartments;
          }
        } else {
          // normal click
        }*/

        /*if( this.notificationBranches.indexOf('0') != -1 || this.notificationBranches.indexOf(0) != -1 ) {

          if( this.notificationBranches.length == 1 && this.departmentListSet.length < 3 ) {
            this.notificationBranches = [];
          } else {

            this.notificationBranches = [];
            this.notificationBranches.push(0);

            for( var b in this.branchList ) {
              this.notificationBranches.push(this.branchList[b].id);
            }
          }

        } else {

          if( this.notificationBranches.length == 1 && this.notificationBranches[0] == '0' ) {

            this.notificationBranches = [];
            this.notificationBranches.push(0);

            for( var b in this.branchList ) {
              this.notificationBranches.push(this.branchList[b].id);
            }

          } else if( this.notificationBranches[0] == '0' || this.notificationBranches.indexOf('0') != -1 ) {

            if( this.notificationBranches.length > 1 ) {
              this.notificationBranches.shift();
            }
            var branchListLength = parseInt(this.branchList.length) - 1;
            var notificationLength = parseInt(this.notificationBranches.length) - 1;

            if( this.notificationBranches.length == branchListLength || notificationLength == branchListLength ) {
              this.notificationBranches = [];
            }
          } else if( this.notificationBranches.indexOf(0) != -1 ) {

            this.notificationBranches = [0];
            this.notificationBranches.push(0);

            for( var b in this.branchList ) {
              this.notificationBranches.push(this.branchList[b].id);
            }
          } else {

            var branchListLength = parseInt(this.branchList.length) - 1;
            if( branchListLength == this.notificationBranches.length ) {
              this.notificationBranches = [];
            }

          }
        }*/
      },
      fncCheckDays(e) {

        var lastClicked = this.notificationSendDays[this.notificationSendDays.length-1];

        if( this.notificationSendDays.indexOf('0') != -1 || this.notificationSendDays.indexOf(0) != -1 ) {

          if (lastClicked == 0) {

            this.notificationSendDays = ["0","1","2","3","4","5","6","7"];
            /*this.notificationSendDays.push(0);

            for( var b in this.branchList ) {
              if( this.branchList[b].id != '0' ) {
                this.notificationSendDays.push(this.branchList[b].id);
              }
            }*/

          } else {

            var unique = [...new Set(this.branchList .map(item => item.id))]; // [ 'A', 'B']
            var uniqueBranches = [...new Set(this.notificationSendDays .map(item => item))]; // [ 'A', 'B']

            var moveZero = false;

            if( ( uniqueBranches.length ) == ( unique.length - 1 ) ) {
              for( var b in this.notificationSendDays ) {
                if( this.notificationSendDays[b] == '0' ) {
                  var index = this.notificationSendDays.indexOf(this.notificationSendDays[b]);
                  if (index !== -1) {
                    moveZero = true;
                  }
                }
              }
            }
          }

          if( moveZero == true ) {
            var newBranches = [];
            for( var b in this.notificationSendDays ) {
              if( this.notificationSendDays[b] != '0' ) {
                newBranches.push( this.notificationSendDays[b]  );
              }
            }
            this.notificationSendDays = newBranches;
          }
        } else {

          var unique = [...new Set(this.branchList .map(item => item.id))];
          var uniqueBranches = [...new Set(this.notificationSendDays .map(item => item))];

          if( this.notificationSendDays.length == ( unique.length - 1 ) ) {
            var index = this.notificationSendDays.indexOf(0);
            if (index == -1) {
              this.notificationSendDays = [];
            }
          }
        }

      },
      fncCheckVendors(e) {

        var lastClicked = this.notificationVendors[this.notificationVendors.length-1];

        if( this.notificationVendors.indexOf('0') != -1 || this.notificationVendors.indexOf(0) != -1 ) {
          if (lastClicked == 0) {

            this.notificationVendors = [];
            this.notificationVendors.push(0);

            var unique = [...new Set(this.vendorManufacturerLinks .map(item => item.id))]; // [ 'A', 'B']

            for( var b in unique ) {
              if( unique[b] != '0' ) {
                this.notificationVendors.push(unique[b]);
              }
            }

          } else {

            var unique = [...new Set(this.vendorManufacturerLinks .map(item => item.id))]; // [ 'A', 'B']
            var uniqueVendors = [...new Set(this.notificationVendors .map(item => item))];

            if( uniqueVendors.length <= unique.length ) {
              this.notificationVendors = e;
              var index = this.notificationVendors.indexOf(0);
              if (index !== -1) {
                this.notificationVendors.splice(index, 1);
              }
            }
          }
        } else {

          var unique = [...new Set(this.vendorManufacturerLinks .map(item => item.id))];
          var index = unique.indexOf(0);
          if (index !== -1) {
            unique.splice(index, 1);
          }

          var uniqueVendors = [...new Set(this.notificationVendors .map(item => item))];

          if( uniqueVendors.length == unique.length ) {
            var index = this.notificationVendors.indexOf(0);
            if (index == -1) {
              this.notificationVendors = [];
            }
          }
        }

      },
      fncCheckDepartments() {

        var lastClicked = this.notificationDepartments[this.notificationDepartments.length-1];

        if( this.notificationDepartments.indexOf('0') != -1 || this.notificationDepartments.indexOf(0) != -1 ) {
          if (lastClicked == 0) {

            this.notificationDepartments = [];
            this.notificationDepartments.push(0);

            for( var b in this.departmentListSet ) {
              if( this.departmentListSet[b].id != '0' ) {
                this.notificationDepartments.push(this.departmentListSet[b].id);
              }
            }

          } else {

            var unique = [...new Set(this.departmentListSet .map(item => item.id))]; // [ 'A', 'B']

            if( this.notificationDepartments.length == ( unique.length - 1 ) ) {
              var index = this.notificationDepartments.indexOf(0);
              if (index !== -1) {
                this.notificationDepartments.splice(index, 1);
              }
            }
          }
        } else {

          var unique = [...new Set(this.departmentListSet .map(item => item.id))];
          if( this.notificationDepartments.length == ( unique.length - 1 ) ) {
            var index = this.notificationDepartments.indexOf(0);
            if (index == -1) {
              this.notificationDepartments = [];
            }
          }
        }

        /*if( this.notificationDepartments.indexOf('0') != -1 || this.notificationDepartments.indexOf(0) != -1 ) {

          console.log('we are in here');

          if( lastClicked == '0' || lastClicked == 0 ) {

          } else {
            var newDepartments = [];
            console.log('Blah');
            console.log( this.notificationDepartments );
            console.log( lastClicked );

          }
        } else {

          console.log('reclicked all');
          console.log(lastClicked);

          // normal click
        }*/
      },
      fncSetModalTitle() {
        if( this.notificationName != '' ) {
          this.$store.commit('setGlobalModalTitle', this.globalModalParams.statusName + ' - ' + this.notificationName);
        } else {
          this.$store.commit('setGlobalModalTitle', this.globalModalParams.statusName);
        }
      },
      fncCloseButtonText() {
        if( this.viewList == false ) {
          return 'CANCEL';
        } else {
          return 'CLOSE';
        }
      },
      /*fncCheckBranchAll() {

        var hasZero = false;

        for( var b in this.notificationBranches ) {
          if( this.notificationBranches[b] == '0' ) {
            hasZero = true;
          }
        }

        if( hasZero == true && this.notificationBranches.length == this.branchList.length ) {
          this.notificationBranches = [];
          this.notificationBranches.push(0);
        } else if( hasZero == true && this.notificationBranches.length != this.branchList.length ) {
          console.log( 'REMOVE ALL' );
        }

      },*/
      fncChangeState( notificationId, newState ) {
        this.$store.dispatch({
          type: 'fncSaveState',
          id: notificationId,
          newState: newState
        });
      },
      fncDisablePaste() {
        var input = document.getElementById("repText");
        var inputCust = document.getElementById("customerText");
        var inputSms = document.getElementById("repSmsText");
        var inputCustSms = document.getElementById("customerSmsText");
        if (input)
          input.onpaste = function(){return false;};

        if (inputCust)
          inputCust.onpaste = function(){return false;};

        if (inputSms)
          inputSms.onpaste = function(){return false;};

        if (inputCustSms)
          inputCustSms.onpaste = function(){return false;};
      },
      fncRecName() {
        return 'Add the '+this.objAuthorize.manu_user_alias+' first name to the message';
      },
      fncRecSurname() {
        return 'Add the '+this.objAuthorize.manu_user_alias+' surname to the message';
      },
      fncRecEmail() {
        return 'Add the '+this.objAuthorize.manu_user_alias+' email to the message';
      },
      fncFalse() {
        return false;
      },
      fncCheckForVendor() {
        var hasVendor = 0;
        for( var r in this.notificationRole ) {
          if( this.vendorType.length > 0 && this.vendorType != null && this.vendorType != undefined ) {
            if( this.vendorType.indexOf(this.notificationRole[r]) != -1 ) {
              this.hasVendorRole = true;
              hasVendor++;
            }
          }
        }
        if( hasVendor == 0 ) {
          this.hasVendorRole = false;
          this.notificationVendors = [];
        }
      },
      fncCheckRoles() {
        this.notificationRole = [];
      },
      fncGetCustomerFlag() {
        if( this.notifyCustomer == true ) {
          return 'Yes';
        } else {
          return 'No';
        }
      },
      fncGetRepFlag() {
        if( this.notifyRep == true ) {
          return 'Yes';
        } else {
          return 'No';
        }
      },
      fncCheckNotificationAction() {

        if( this.apiData.isApi == true || this.apiData.isApi == 'true' ) {
          var canSubmit = false;
          if( this.notificationName == '' ) {
            canSubmit = true;
          }
        } else {
          var canSubmit = false;
          if( this.notificationName == '' || this.notificationType == '' || this.notificationMethod.length == 0 ) {
            canSubmit = true;
          } else {
            canSubmit = false;
          
            if( this.notificationRole.length == 0 && this.notifyCustomer == false  ) {
              canSubmit = true;
            }
            if( this.notificationRole.length == 0 && this.notifyVendor == false  ) {
              if( this.notifyRep == true ) {
                canSubmit = true;  
              } else {
                canSubmit = false;
              }
            }
            if( this.notifyRep == true && this.notificationMethod.indexOf('email') != -1 && ( this.repWysiwig == '' || this.notificationSubject == '' ) /*&& ( this.notificationRole.length > 0 && isNaN(this.notificationRole[0]) )*/ ) {
              canSubmit = true;
            }
            /*if( this.notifyRep == true && this.notificationMethod.indexOf('sms') != -1 && this.notificationSmsMessage == '' ) {
              canSubmit = true;
            }*/
            if( this.notificationMethod.indexOf('email') != -1 && this.notifyCustomer == true && ( this.customerWysiwig == '' || this.notificationCustomerSubject == '' ) ) {
              canSubmit = true;
            }
            /*if( this.notificationMethod.indexOf('sms') != -1 && this.notifyCustomer == true && this.notificationCustomerSmsMessage == '' ) {
              canSubmit = true;
            }*/
            if( this.notifyDaily == true && this.notificationType != 3 ) {
              if( this.notificationHours == 0 && this.notificationDays == 0 ) {
                canSubmit = true;
              }
              if( this.notificationTime == '' ) {
                canSubmit = true;
              }
            }
          }
        }

        return canSubmit;
      },
      notifyVendorEventListener(event){
       if ( event === false){
         this.notificationRole = []
       }
      },
      fncReplacePreviewValues(strValue) {
        strValue = strValue.replace('[YOUR_COMPANY_NAME]', '<span style="background: #EFEFEF;font-weight: bold;"><i>Company XYZ</i></span>');
        strValue = strValue.replace('[QUOTE_NO]', '<span style="background: #EFEFEF;font-weight: bold;"><i>QTE000086</i></span>');
        strValue = strValue.replace('[QUOTE_DATE]', '<span style="background: #EFEFEF;font-weight: bold;"><i>2019-01-01</i></span>');
        strValue = strValue.replace('[QUOTE_STATUS]', '<span style="background: #EFEFEF;font-weight: bold;"><i>Status Name</i></span>');
        strValue = strValue.replace('[REP_NAME]', '<span style="background: #EFEFEF;font-weight: bold;"><i>John</i></span>');
        strValue = strValue.replace('[RECIPIENT_NAME]', '<span style="background: #EFEFEF;font-weight: bold;"><i>Michael</i></span>');
        strValue = strValue.replace('[REP_SURNAME]', '<span style="background: #EFEFEF;font-weight: bold;"><i>Smith</i></span>');
        strValue = strValue.replace('[RECIPIENT_SURNAME]', '<span style="background: #EFEFEF;font-weight: bold;"><i>Matthews</i></span>');
        strValue = strValue.replace('[REP_EMAIL]', '<span style="background: #EFEFEF;font-weight: bold;"><i>johnsmith@rep.com</i></span>');
        strValue = strValue.replace('[REP_TEL]', '<span style="background: #EFEFEF;font-weight: bold;"><i>083 365 5645</i></span>');
        strValue = strValue.replace('[RECIPIENT_EMAIL]', '<span style="background: #EFEFEF;font-weight: bold;"><i>michaelmatthews@recipient.com</i></span>');
        strValue = strValue.replace('[CUSTOMER_NAME]', '<span style="background: #EFEFEF;font-weight: bold;"><i>Piet</i></span>');
        strValue = strValue.replace('[CUSTOMER_SURNAME]', '<span style="background: #EFEFEF;font-weight: bold;"><i>Botha</i></span>');
        strValue = strValue.replace('[CUSTOMER_EMAIL]', '<span style="background: #EFEFEF;font-weight: bold;"><i>pietbotha@customer.com</i></span>');
        strValue = strValue.replace('[CUSTOMER_TEL]', '<span style="background: #EFEFEF;font-weight: bold;"><i>072 585 5412</i></span>');
        strValue = strValue.replace('[CUSTOMER_COMPANY]', '<span style="background: #EFEFEF;font-weight: bold;"><i>XYZ Movers</i></span>');
        strValue = strValue.replace('[QUOTE_TOTAL_VATEXCL]', '<span style="background: #EFEFEF;font-weight: bold;"><i>R10,000.00</i></span>');
        strValue = strValue.replace('[QUOTE_TOTAL_VATINCL]', '<span style="background: #EFEFEF;font-weight: bold;"><i>R11,500.00</i></span>');
        strValue = strValue.replace('[QUOTE_SUMMARY]', '<span style="background: #EFEFEF;"><table cellpadding="20" class="previewTable"><tr><th>Quote No</th><th>Rep Name</th><th>Company Name</th><th>Customer Name</th><th>Quote Date</th><th>Time since last status change</th><th>Status</th><th>Value Ex VAT</th></tr><tr><td>QTE000084</td><td>John Lemon</td><td>XYZ Flooring</td><td>Jane Doe</td><td>01-01-2018</td><td>2 days</td><td>Ordered</td><td>R11,500.00</td></tr></table></span>');
        strValue = strValue.replace('[QUOTE_ACCEPT_REJECT]', '<span style="background: #EFEFEF;"><table cellpadding="20" class="previewTable"><tr><td><button style="background: green !important; padding: 8px;color: #fff !important;">ACCEPT</button></td><td><button style="background: red !important; padding: 8px;color: #fff !important;">REJECT</button></td></tr></table></span>');
        /*strValue = strValue.replace('[QUOTE_ACCEPT_REJECT_FINAL]', '<span style="background: #EFEFEF;"><table cellpadding="20" class="previewTable"><tr><td><button style="background: green !important; padding: 8px;color: #fff !important;">ACCEPT</button></td><td><button style="background: red !important; padding: 8px;color: #fff !important;">REJECT</button></td></tr></table></span>');
        strValue = strValue.replace('[QUOTE_ACCEPT_REJECT_FINAL]', '<span style="background: #EFEFEF;"><table cellpadding="20" class="previewTable"><tr><td><button style="background: green !important; padding: 8px;color: #fff !important;">ACCEPT</button></td><td><button style="background: red !important; padding: 8px;color: #fff !important;">REJECT</button></td></tr></table></span>');*/
        strValue = strValue.replace('[CUSTOMER_DELIVERY_DETAILS]', '<span style="background: #EFEFEF;font-weight: bold;"><i>Collect</i></span>');
        strValue = strValue.replace('[QUOTE_DIRECT_LINK]', '<span style="background: #EFEFEF;font-weight: bold;"><i>View Report</i></span>');
        strValue = strValue.replace('[QUOTE_DIRECT_LINK_PURCHASE_ORDER]', '<span style="background: #EFEFEF;font-weight: bold;"><i>View Report</i></span>');
        strValue = strValue.replace('[SALES_ORDER_NUMBER]', '<span style="background: #EFEFEF;font-weight: bold;"><i>245034975058</i></span>');
        strValue = strValue.replace('[QUOTE_SO_NUMBER]', '<span style="background: #EFEFEF;font-weight: bold;"><i>245034975058</i></span>');
        strValue = strValue.replace('[QUOTE_STORE]', '<span style="background: #EFEFEF;font-weight: bold;"><i>Plumstead</i></span>');
        strValue = strValue.replace('[QUOTE_STATUS_REASON]', '<span style="background: #EFEFEF;font-weight: bold;"><i>Too expensive</i></span>');
        strValue = strValue.replace('[QUOTE_TIME_IN_STATUS]', '<span style="background: #EFEFEF;font-weight: bold;"><i>2 Days</i></span>');
        strValue = strValue.replace('[SERVICE_TYPE]', '<span style="background: #EFEFEF;font-weight: bold;"><i>Contact Customer</i></span>');
        strValue = strValue.replace('[QUOTE_COMMERCIAL_KAM]', '<span style="background: #EFEFEF;font-weight: bold;"><i>John Marais</i></span>');
        strValue = strValue.replace('[QUOTE_COMMERCIAL_COORDINATOR]', '<span style="background: #EFEFEF;font-weight: bold;"><i>Mary Matthews</i></span>');
        strValue = strValue.replace('[CUSTOMER_COMPANY]', '<span style="background: #EFEFEF;font-weight: bold;"><i>Builders Warehouse</i></span>');
        // strValue = strValue.replace('[QUOTE_DETAIL]', '<span style="background: #EFEFEF;"><table cellpadding="5" style="width:100%;background:#EFEFEF;"><tbody style="min-height: auto !important;"><tr><td style="width:50%;"><strong>Customer Name</strong></td><td>Jaime Bell</td></tr><tr><td width="50%"><strong>Quote NO</strong></td><td>QTE000036</td></tr><tr><td width="50%"><strong>Date of Issue</strong></td><td>21-08-2019</td></tr></tbody></table><table cellpadding="5" style="width:100%;background:#EFEFEF;"><tbody style="min-height: auto !important;"><tr><td style="width:20%"><strong>Item</strong></td><td style="width:20%"><strong>QTY</strong></td><td style="width:20%"><strong>UOM</strong></td><td style="width:20%"><strong>Unit Gross Cost</strong></td><td style="width:20%"><strong>Total Nett Cost</strong></td></tr><tr><td style="width:20%">Item Name</td><td style="width:20%">2</td><td style="width:20%">meter</td><td style="width:20%">R2000.00</td><td style="width:20%">R4000.00</td></tr><tr><td colspan="3" width="60%">&nbsp;<td><td colspan="2" width="40%"><br/><table width="75%"><tbody style="min-height: auto !important;"><tr><td>SUB-TOTAL</td><td>R4000.00</td></tr><tr><td>VAT @ 15%</td><td>R600.00</td></tr><tr><td colspan="2">&nbsp;</td></tr><tr><td><strong>TOTAL COST</strong></td><td>R4600.00</td></tr></tbody></table></td></tr></tbody></table></span>');
        return '<br />' + strValue;
      },
      fncShowInternalEmailPreview(status) {
        this.internalEmailPreview = status;
      },
      fncContentInternalEmail() {
        if (this.repWysiwig) {
          //return this.fncReplacePreviewValues(this.repWysiwig.getContent());
          return this.fncReplacePreviewValues(this.repWysiwig);
        } else {
          return '';
        }
      },
      fncContentCustomerEmail() {
        if (this.customerWysiwig) {
          return this.fncReplacePreviewValues(this.customerWysiwig);
        } else {
          return '';
        }
      },
      fncContentInternalSms() {
        return this.fncReplacePreviewValues(this.notificationSmsMessage);
      },
      fncContentCustomerSms() {
        return this.fncReplacePreviewValues(this.notificationCustomerSmsMessage);
      },
      fncShowInternalSmsPreview(status) {
        this.internalSmsPreview = status;
      },
      fncShowCustomerEmailPreview(status) {
        this.customerEmailPreview = status;
      },
      fncShowCustomerSmsPreview(status) {
        this.customerSmsPreview = status;
      },
      fncSetShortcode(shortcode, type) {
        if (type == 'rep') {

          var myField = document.getElementById('repText');

          var myValue = shortcode;

          if (document.selection) {
            myField.focus();
            sel = document.selection.createRange();
            sel.text = myValue;
          } else if(window.navigator.userAgent.indexOf("Edge") > -1) {
            var startPos = myField.selectionStart;
            var endPos = myField.selectionEnd;

            myField.value = myField.value.substring(0, startPos)+ myValue
                    + myField.value.substring(endPos, myField.value.length);

            var pos = startPos + myValue.length;
            myField.focus();
            myField.setSelectionRange(pos, pos);
          } else if (myField.selectionStart || myField.selectionStart == '0') {
            var startPos = myField.selectionStart;
            var endPos = myField.selectionEnd;
            myField.value = myField.value.substring(0, startPos)
                    + myValue
                    + myField.value.substring(endPos, myField.value.length);
            myField.focus();
          } else {
            myField.value += myValue;
          }

          this.repWysiwig = myField.value;

        } else if ( type == 'customer' ) {
          /*var customerContent = this.customerWysiwig;
              customerContent = customerContent + ' ' + shortcode;
          this.customerWysiwig = customerContent;*/

          var myField = document.getElementById('customerText');
          var myValue = shortcode;

          if (document.selection) {
            myField.focus();
            sel = document.selection.createRange();
            sel.text = myValue;
          } else if(window.navigator.userAgent.indexOf("Edge") > -1) {
            var startPos = myField.selectionStart;
            var endPos = myField.selectionEnd;

            myField.value = myField.value.substring(0, startPos)+ myValue
                    + myField.value.substring(endPos, myField.value.length);

            var pos = startPos + myValue.length;
            myField.focus();
            myField.setSelectionRange(pos, pos);
          } else if (myField.selectionStart || myField.selectionStart == '0') {
            var startPos = myField.selectionStart;
            var endPos = myField.selectionEnd;
            myField.value = myField.value.substring(0, startPos)
                    + myValue
                    + myField.value.substring(endPos, myField.value.length);
          } else {
            myField.value += myValue;
          }

          this.customerWysiwig = myField.value;

        }
      },
      fncSetShortcodeSms(shortcode, type) {
        if (type == 'rep') {

          var myField = document.getElementById('repSmsText');
          var myValue = shortcode;

          if (document.selection) {
            myField.focus();
            sel = document.selection.createRange();
            sel.text = myValue;
          } else if(window.navigator.userAgent.indexOf("Edge") > -1) {
            var startPos = myField.selectionStart;
            var endPos = myField.selectionEnd;

            myField.value = myField.value.substring(0, startPos)+ myValue
                    + myField.value.substring(endPos, myField.value.length);

            var pos = startPos + myValue.length;
            myField.focus();
            myField.setSelectionRange(pos, pos);
          } else if (myField.selectionStart || myField.selectionStart == '0') {
            var startPos = myField.selectionStart;
            var endPos = myField.selectionEnd;
            myField.value = myField.value.substring(0, startPos)
                    + myValue
                    + myField.value.substring(endPos, myField.value.length);
          } else {
            myField.value += myValue;
          }

          this.notificationSmsMessage = myField.value;

          /*var repContent = this.notificationSmsMessage;
              repContent = repContent + ' ' + shortcode;
          this.notificationSmsMessage = repContent;*/
        } else if (type == 'customer') {

          var myField = document.getElementById('customerSmsText');
          var myValue = shortcode;

          if (document.selection) {
            myField.focus();
            sel = document.selection.createRange();
            sel.text = myValue;
          } else if(window.navigator.userAgent.indexOf("Edge") > -1) {
            var startPos = myField.selectionStart;
            var endPos = myField.selectionEnd;

            myField.value = myField.value.substring(0, startPos)+ myValue
                    + myField.value.substring(endPos, myField.value.length);

            var pos = startPos + myValue.length;
            myField.focus();
            myField.setSelectionRange(pos, pos);
          } else if (myField.selectionStart || myField.selectionStart == '0') {
            var startPos = myField.selectionStart;
            var endPos = myField.selectionEnd;
            myField.value = myField.value.substring(0, startPos)
                    + myValue
                    + myField.value.substring(endPos, myField.value.length);
          } else {
            myField.value += myValue;
          }

          this.notificationCustomerSmsMessage = myField.value;

          /*var customerContent = this.notificationCustomerSmsMessage;
              customerContent = customerContent + ' ' + shortcode;
          this.notificationCustomerSmsMessage = customerContent;*/
        }
      },
      fncGetRepRoles( type ) {
        this.filteredUserTypes = [];
        for( var u in this.userRoles ) {
          if( type == true ) {
            // if( this.userRoles[u].user_type == 1 ) {
              this.filteredUserTypes.push(this.userRoles[u]);
            // }
          } else {
            /*if( this.userRoles[u].user_type == 1 || this.userRoles[u].user_type == 6 ) {*/
            if( this.userRoles[u].user_type == 1 ) {
              this.filteredUserTypes.push(this.userRoles[u]);
            }
          }
        }
      },
      fncCheckDaily() {
        this.notificationMethod = [];
        this.notificationRole = [];
        if (this.notifyDaily == true) {
          this.notifyCustomer = false;
          this.notificationVendors = [];
          this.fncGetRepRoles(true);
          this.notificationMethods = [
            { id: 'email', name: 'Email' }
          ];
        } else {
          this.notificationVendors = [];
          this.fncGetRepRoles(false);
          this.notificationMethods = [
            { id: 'email', name: 'Email' },
            { id: 'sms', name: 'Whatsapp' }
          ];
        }
      },
      fncHideModal () {
        if( this.viewList == true ) {
          // this.$store.commit('hideModal');
          window.location.reload()
        } else {
          this.fncEmptyAll();
          this.notificationFormKey++;
          this.viewList = !this.viewList;
        }
      },
      fncEmptyAll() {
        this.notificationDepartments = [];
        this.notificationBranches = [];
        this.notificationId = '';
        this.notificationName = '';
        this.notificationRole = [];
        this.notificationRoleIgnore = [];
        this.notificationVendors = [];
        this.notificationType = '';
        this.notificationQuoteType = '';
        this.notificationServiceType = '';
        this.notifyStatusStatus = 0;
        this.notifyStatusDays = 0;
        this.notifyStatusHours = 0;
        this.notificationYears = 0;
        this.notificationHours = 0;
        this.notificationDays = 0;
        this.notificationvalue = '';
        this.notifyRep = true;
        this.notifyIsStore = false;
        this.notificationMessage = '';
        this.notificationCustomerMessage = '';
        this.notificationMethod = [];
        this.notificationSendDays = ["0","1","2","3","4","5","6","7"];
        this.notifyCustomer = false;
        this.notifyVendor = false;
        this.notifyOriginator = false;
        this.isCallout = false;
        this.notifyKam = false;
        this.notifyCoordinator = false;
        this.notifyDaily = false;
        this.notificationTime = '';
        this.notificationValue = 0;
        this.notificationAge = 30;
        this.notificationSubject = '';
        this.notificationUserCats = [];
        this.notificationCustomerSubject = '';
        this.notificationSmsMessage = '';
        this.notificationWhatsappTemplate = '';
        this.notificationWhatsappTemplateCustomer = '';
        this.notificationCustomerSmsMessage = '';
        this.hideInternalTemplate = false;
        this.hideCustomerTemplate = false;
        this.templateMessageInternal = '';
        this.templateMessageCustomer = '';
        this.notifyAddPdf = false;
        this.attachDeliveryNote = false;
        this.attachDeliveryNoteCustomer = false;
        this.attachServiceFormFull = false;
        this.attachServiceFormClient = false;
        this.attachServiceFormFullCustomer = false;
        this.attachServiceFormClientCustomer = false;
        this.notifyAddPoPdfVendor = false;
        this.notifyAddPdfCustomer = false;
        this.notifyAddPdfSoCustomer = false;
        this.notificationHeader = [
          { text: 'Name', value: 'name', width: '35%' },
          { text: 'Department', value: 'updated', width: '10%' },
          { text: 'Type', value: 'updated', width: '20%' },
          { text: 'Edit', value: 'edit', width: '10%' },
          { text: 'Delete', value: 'delete', width: '10%' },
          { text: 'Active / Deactivated', value: 'delete', width: '15%' }
        ];
        this.notificationTypes = [
          { id: 1, name: 'On Change to this Status' },
          { id: 2, name: 'On lack of change from this status' },
          { id: 3, name: 'On lack of change from another status to this status' }
        ];
        this.notificationReportTypes = [
          { id: false, name: 'Send as trigger event occurs' },
          { id: true, name: 'Send summary at the end of the day' }
        ];
        this.notificationTimes = [
          { id: '00:00', name: '00:00 am' },
          { id: '02:00', name: '02:00 am' },
          { id: '04:00', name: '04:00 am' },
          { id: '06:00', name: '06:00 am' },
          { id: '08:00', name: '08:00 am' },
          { id: '10:00', name: '10:00 am' },
          { id: '12:00', name: '12:00 pm' },
          { id: '14:00', name: '14:00 pm' },
          { id: '16:00', name: '16:00 pm' },
          { id: '18:00', name: '18:00 pm' },
          { id: '20:00', name: '20:00 pm' },
          { id: '22:00', name: '22:00 pm' }
        ];
        this.notificationMethods = [
          { id: 'email', name: 'Email' },
          { id: 'sms', name: 'Whatsapp' },
        ];
        this.apiData = {
            isApi: false,
            apiAuth: false,
            apiAuthUrl: '',
            apiAuthDataType: '',
            apiDataType: '',
            apiAuthData: '',
            apiData: '',
            apiUrl: ''
        },
        this.repWysiwig = '';
        this.customerWysiwig = '';
        this.internalEmailPreview = false;
        this.internalSmsPreview = false;
        this.customerEmailPreview = false;
        this.customerSmsPreview = false;
        this.hasVendorRole = false;

      },
      fncToggleDisplay() {
        this.fncEmptyAll();
        this.notificationFormKey++;
        this.viewList = !this.viewList;
        this.$nextTick(() => {
          if (this.$refs.startTab) {
            this.$refs.startTab.click();
          }
        });
        if (this.viewList == false) {
          this.fncSetupWysiwigs('','');
        }
        for( var d in this.departmentList ) {
          var objDeps = this.globalModalParams.statusDepartment.split(',');
          for( var od in objDeps ) {
            objDeps[od] = parseInt(objDeps[od]);
          }
          if( objDeps.indexOf( this.departmentList[d].id ) != -1 ) {
            // this.notificationDepartments.push( this.departmentList[d].id );
          }
        }
        this.notificationBranches = [];
        this.notificationBranches.push(0);

        for( var b in this.branchList ) {
          if( this.branchList[b].id != '0' ) {
            this.notificationBranches.push(this.branchList[b].id);
          }
        }

        for( var d in this.departmentListSet ) {
          if( d != 0 ) {
            if( this.departmentListSet[d].id == '0' ) {
              this.departmentListSet.splice( d, 1 );
            }
          }
        }

        this.notificationDepartments = [];

        /*this.notificationDepartments.push(0);

        for( var d in this.departmentListSet ) {
          this.notificationDepartments.push(this.departmentListSet[d].id);
        }*/

        //for( var b in this.branchList ) {
          // this.notificationBranches.push( this.branchList[b].id );
        //}
      },
      fncSetupWysiwigs( repValue, customerValue ) {
        /*var repContainer = document.getElementById("repContainer");
        var customerContainer = document.getElementById("customerContainer");

        if( repContainer || repValue != '' ) {
          this.repWysiwig = createEditor('#repContainer', {
            toolbar: [
              'bold', 'italic', 'foreColor'
            ]
          });
          this.repWysiwig.setContent(repValue);
        }

        if( customerContainer || customerValue != '' ) {
          this.customerWysiwig = createEditor('#customerContainer', {
            toolbar: [
              'bold', 'italic', 'foreColor'
            ]
          });

          this.customerWysiwig.setContent(customerValue);
        }*/
      },
      fncEditNotification(index) {

        this.fncEmptyAll();

        this.$store.commit('setGlobalModalTitle', this.globalModalParams.statusName + ' - ' + this.statusNotificationList[index].name);

        this.notificationFormKey++;
        this.viewList = !this.viewList;
        this.$nextTick(() => {
          if (this.$refs.startTab) {
            this.$refs.startTab.click();
          }
        });

        this.notificationMessage = this.statusNotificationList[index].message;
        this.notificationId = index;
        this.notificationName = this.statusNotificationList[index].name;
        this.notificationRole = typeof this.statusNotificationList[index].roles == 'string' ? this.fncSplitIntoInt(this.statusNotificationList[index].roles) : this.statusNotificationList[index].roles;

        if( this.statusNotificationList[index].roles_ignore == null ) {
          this.notificationRoleIgnore = [];
        } else {
          this.notificationRoleIgnore = typeof this.statusNotificationList[index].roles_ignore == 'string' ? this.fncSplitIntoInt(this.statusNotificationList[index].roles_ignore) : this.statusNotificationList[index].roles_ignore;
        }
        if( this.statusNotificationList[index].branches == null || this.statusNotificationList[index].branches == 'null' ) {
          this.notificationBranches = [];
        } else {
          this.notificationBranches = typeof this.statusNotificationList[index].branches == 'string' ? this.fncSplitIntoInt(this.statusNotificationList[index].branches) : this.statusNotificationList[index].branches;
          if( this.notificationBranches.length == 1 && this.notificationBranches[0] == '0' ) {
            this.notificationBranches = [];
          }
          if( this.notificationBranches.length == this.branchList.length && this.notificationBranches[0] != '0' ) {
            this.notificationBranches.unshift(0);
          }
        }
        if( this.statusNotificationList[index].direct == null || this.statusNotificationList[index].direct == 'null' ) {
          this.notificationDirectReport = [];
        } else {        
          this.notificationDirectReport = typeof this.statusNotificationList[index].direct == 'string' ? this.fncSplitIntoStr(this.statusNotificationList[index].direct) : this.statusNotificationList[index].direct;
          /*if( this.notificationDirectReport.length == 1 && this.notificationDirectReport[0] == '0' ) {
            this.notificationDirectReport = [];
          }*/
        }
        if( this.statusNotificationList[index].report_vendors == null || this.statusNotificationList[index].report_vendors == 'null' ) {
          this.notificationReportVendors = [];
        } else {
          this.notificationReportVendors = typeof this.statusNotificationList[index].report_vendors == 'string' ? this.fncSplitIntoInt(this.statusNotificationList[index].report_vendors) : this.statusNotificationList[index].report_vendors;
        }

        if( this.statusNotificationList[index].departments == null || this.statusNotificationList[index].departments == 'null' ) {
          this.notificationDepartments = [];
        } else {
          this.notificationDepartments = typeof this.statusNotificationList[index].departments == 'string' ? this.fncSplitIntoInt(this.statusNotificationList[index].departments) : this.statusNotificationList[index].departments;
          if( this.notificationDepartments.length == 1 && this.notificationDepartments[0] == '0' ) {
            this.notificationDepartments = [];
          }
          if( this.notificationDepartments.length == this.departmentList.length && this.notificationDepartments[0] != '0' ) {
            this.notificationDepartments.unshift(0);
          }
        }
        this.notificationVendors = typeof this.statusNotificationList[index].vendors == 'string' ? this.fncSplitIntoInt(this.statusNotificationList[index].vendors) : this.statusNotificationList[index].vendors;
        if( this.notificationVendors.length == 1 && this.notificationVendors[0] == '0' ) {
          this.notificationVendors = [];
        }
        if( this.notificationRole.length == 1 && this.notificationRole[0] == '0' ) {
          this.notifyRep = false;
          this.notificationRole = [];
        }

        this.notificationType = this.statusNotificationList[index].type_id;
        this.notificationQuoteType = (this.statusNotificationList[index].notification_quote_type === null) ? "" : this.statusNotificationList[index].notification_quote_type;
        this.notificationServiceType = (this.statusNotificationList[index].notification_service_type === null) ? "" : this.statusNotificationList[index].notification_service_type;
        this.notifyStatusStatus = this.statusNotificationList[index].status_status;
        this.notifyStatusDays = this.statusNotificationList[index].status_days;
        this.notifyStatusHours = this.statusNotificationList[index].status_hours;
        this.notificationYears = this.statusNotificationList[index].years;
        this.notificationHours = this.statusNotificationList[index].hours;
        this.notificationDays = this.statusNotificationList[index].days;
        this.notificationMethod = typeof this.statusNotificationList[index].method == 'string' ? this.statusNotificationList[index].method.split(',') : this.statusNotificationList[index].method;
        this.notifyCustomer = this.statusNotificationList[index].notify_customer;
        this.notifyVendor = this.statusNotificationList[index].notify_vendor;
        this.notifyOriginator= this.statusNotificationList[index].notify_originator;
        this.isCallout= this.statusNotificationList[index].is_callout;
        this.notifyKam= this.statusNotificationList[index].notify_kam;
        this.notifyCoordinator = this.statusNotificationList[index].notify_coordinator;
        this.notifyDaily = this.statusNotificationList[index].notify_daily == 1 ? true : false;
        this.notificationTime = this.statusNotificationList[index].notification_time;
        this.notificationValue = this.statusNotificationList[index].quote_value;
        this.notificationAge = this.statusNotificationList[index].age;
        this.notificationMessage = this.statusNotificationList[index].message;
        this.notificationSubject = this.statusNotificationList[index].subject;
        this.notificationCats = this.statusNotificationList[index].notification_attachment_categories != null ? this.statusNotificationList[index].notification_attachment_categories.split(',') : [];
        this.notificationUserCats = this.statusNotificationList[index].notification_attachment_categories_users != null ? this.statusNotificationList[index].notification_attachment_categories_users.split(',') : [];

        if( this.statusNotificationList[index].notification_send_days == '0' || this.statusNotificationList[index].notification_send_days == '' ) {
          this.notificationSendDays = ["0","1","2","3","4","5","6","7"];
        } else {
          this.notificationSendDays = this.statusNotificationList[index].notification_send_days.split(',');          
        }

        var objNotificationCats = [];
        if( this.notificationCats.length > 0 ) {
          for( var c in this.notificationCats ) {
            objNotificationCats.push( parseInt( this.notificationCats[c] ) );
          }
        }

        this.notificationCats = objNotificationCats;

        var objNotificationCats = [];
        if( this.notificationUserCats.length > 0 ) {
          for( var c in this.notificationUserCats ) {
            objNotificationCats.push( parseInt( this.notificationUserCats[c] ) );
          }
        }

        this.notificationUserCats = objNotificationCats;

        this.notificationCustomerSubject = this.statusNotificationList[index].customer_subject;
        this.notificationSmsMessage = this.statusNotificationList[index].sms_message;
        this.notificationWhatsappTemplate = this.statusNotificationList[index].whatsapp_template;

        if( this.notificationWhatsappTemplate != '' ) {
          this.hideInternalTemplate = true;
        } else {
          this.hideInternalTemplate = false;
        }

        this.notificationWhatsappTemplateCustomer = this.statusNotificationList[index].whatsapp_template_customer;      
        if( this.notificationWhatsappTemplateCustomer != '' ) {
          this.hideCustomerTemplate = true;
        } else {
          this.hideCustomerTemplate = false;
        }

        this.notificationCustomerSmsMessage = this.statusNotificationList[index].customer_sms_message;
        this.repWysiwig = this.statusNotificationList[index].message;
        this.customerWysiwig = this.statusNotificationList[index].customer_message;
        this.notifyAddPdf = this.statusNotificationList[index].add_pdf;
        this.attachDeliveryNote = this.statusNotificationList[index].attach_delivery_note;
        this.attachDeliveryNoteCustomer = this.statusNotificationList[index].attach_delivery_note_customer;
        this.attachServiceFormFull = this.statusNotificationList[index].attach_service_form_full;
        this.attachServiceFormClient = this.statusNotificationList[index].attach_service_form_client;
        this.attachServiceFormFullCustomer = this.statusNotificationList[index].attach_service_form_full_customer;
        this.attachServiceFormClientCustomer = this.statusNotificationList[index].attach_service_form_client_customer;
        this.notifyAddPoPdfVendor = this.statusNotificationList[index].add_pdf_po_vendor;
        this.notifyAddPdfCustomer = this.statusNotificationList[index].add_pdf_customer;
        this.notifyAddPdfSoCustomer = this.statusNotificationList[index].add_pdf_so_customer;

        //this.apiData = this.statusNotificationList[index].api_data;
        var apiDataParsed = this.statusNotificationList[index].api_data;
        try {
          this.apiData = JSON.parse(this.statusNotificationList[index].api_data);
        } catch (e) {
          this.apiData = this.statusNotificationList[index].api_data;
        }
        //this.apiData = JSON.parse( this.apiData );

        if( this.apiData.isApi == 'false' ) { this.apiData.isApi = false; }
        if( this.apiData.isApi == 'true' ) { this.apiData.isApi = true; }

        if( this.apiData.apiAuth == 'false' ) { this.apiData.apiAuth = false; }
        if( this.apiData.apiAuth == 'true' ) { this.apiData.apiAuth = true; }

        this.fncCheckForVendor();

        if( this.notifyDaily == true ) {
          this.notificationMethods = [
            { id: 'email', name: 'Email' }
          ];
        } else {
          this.notificationMethods = [
            { id: 'email', name: 'Email' },
            { id: 'sms', name: 'Whatsapp' }
          ];
        }

        // need to check the user roles as well
        for( var x in this.userRoles ) {
          if( this.userRoles[x].user_type == '6' ) {
            if( this.notificationRole.indexOf(this.userRoles[x].id) != -1 ) {
              this.notifyVendor = true;
            }
          }
        }

        if( this.statusNotificationList[index].is_per_store == '1' ) {
            this.notifyIsStore = true;
        } else {
            this.notifyIsStore = false;
        }

        let parsedData;
        try {
          parsedData = JSON.parse(apiDataParsed);
        } catch (e) {
          parsedData = {};
        }

        if (parsedData.isApi === 'false' || parsedData.isApi === false || parsedData.isApi === 'undefined' || parsedData.isApi === undefined) {
          this.apiData = {
            isApi: false,
            apiAuth: false,
            apiAuthUrl: '',
            apiAuthDataType: '',
            apiDataType: '',
            apiAuthData: '',
            apiData: '',
            apiUrl: ''
          };
        } else {
          this.apiData = JSON.parse(this.statusNotificationList[index].api_data);
        }


      },
      fncSplitIntoInt(str) {
        var tmpArr = [];
        var strSplit = str.split(',');
        for (var s in strSplit) {
          tmpArr.push(parseInt(strSplit[s]));
        }
        return tmpArr;
      },
      fncSplitIntoStr(str) {

         var tmpArr = [];
          var strSplit = str.split(',');

          for (var i = 0; i < strSplit.length; i++) {
              tmpArr.push(Number(strSplit[i].trim()));
          }

          return tmpArr;

        /*var tmpArr = [];
        var strSplit = str.split(',');
        for (var s in strSplit) {
          tmpArr.push(String(strSplit[s]));
        }
        return tmpArr;*/
      },
      fncDeleteNotifications(notification) {
        var confirmDelete = confirm('Are you sure you would like to remove this notification?');
        if (confirmDelete === true) {
          this.$store.dispatch({
            type: 'fncDeleteNotification',
            id: notification.id,
            status: notification.status_id
          })
        }
      },
      fncAddNotification() {

        this.canSave = true;
        let smsMessage = this.notificationSmsMessage;
        let customerSmsMessage = this.notificationCustomerSmsMessage;

        if( this.hideInternalTemplate == true && this.notificationWhatsappTemplate != '' && this.notificationWhatsappTemplate != '0' ) {
          smsMessage = this.fncCollectTwilioTemplateVariables('templateMessageInternalHolder', this.notificationWhatsappTemplate);
        }

        if( this.hideCustomerTemplate == true && this.notificationWhatsappTemplateCustomer != '' && this.notificationWhatsappTemplateCustomer != '0' ) {
          customerSmsMessage = this.fncCollectTwilioTemplateVariables('templateMessageCustomerHolder', this.notificationWhatsappTemplateCustomer);
        }

        var notificationSendDays = typeof this.notificationSendDays == 'string' ? this.notificationSendDays : this.notificationSendDays.join(',');

        this.statusNotificationList.push({
          name: this.notificationName,
          roles: this.notificationRole,
          roles_ignore: this.notificationRoleIgnore,
          vendors: this.notificationVendors,
          type_id: this.notificationType,
          notification_quote_type: this.notificationQuoteType,
          notification_service_type: this.notificationServiceType,
          status_status: this.notifyStatusStatus,
          status_days: this.notifyStatusDays,
          status_hours: this.notifyStatusHours,
          years: this.notificationYears,
          days: this.notificationDays,
          hours: this.notificationHours,
          method: this.notificationMethod,
          message: this.repWysiwig,
          customer_message: this.customerWysiwig,
          notify_customer: this.notifyCustomer,
          notify_vendor: this.notifyVendor,
          notify_originator: this.notifyOriginator,
          is_callout: this.isCallout,
          is_per_store: this.notifyIsStore == true || this.notifyIsStore == 1 ? 1 : 0,
          notify_kam: this.notifyKam,
          notify_coordinator: this.notifyCoordinator,
          notify_daily: this.notifyDaily,
          notification_time: this.notificationTime,
          quote_value: this.notificationValue,
          age: this.notificationAge,
          branches: this.notificationBranches,
          direct: this.notificationDirectReport,
          report_vendors: this.notificationReportVendors,
          departments: this.notificationDepartments,
          subject: this.notificationSubject,
          notification_attachment_categories: this.notificationCats,
          notification_attachment_categories_users: this.notificationUserCats,
          customer_subject: this.notificationCustomerSubject,
          sms_message: smsMessage,
          whatsapp_template: this.notificationWhatsappTemplate,
          whatsapp_template_customer: this.notificationWhatsappTemplateCustomer,
          customer_sms_message: customerSmsMessage,
          add_pdf: this.notifyAddPdf == true ? 1 : 0,
          attach_service_form_full: this.attachServiceFormFull == true ? 1 : 0,
          attach_service_form_client: this.attachServiceFormClient == true ? 1 : 0,
          attach_service_form_full_customer: this.attachServiceFormFullCustomer == true ? 1 : 0,
          attach_service_form_client_customer: this.attachServiceFormClientCustomer == true ? 1 : 0,
          add_pdf_po_vendor: this.notifyAddPoPdfVendor == true ? 1 : 0,
          add_pdf_customer: this.notifyAddPdfCustomer == true ? 1 : 0,
          add_pdf_so_customer: this.notifyAddPdfSoCustomer == true ? 1 : 0,
          apiData: this.apiData,
          attach_delivery_note: this.attachDeliveryNote == true ? 1 : 0,
          attach_delivery_note_customer: this.attachDeliveryNoteCustomer == true ? 1 : 0,
          notification_send_days: notificationSendDays,

        });

        this.viewList = !this.viewList;
        this.notificationFormKey++;
        this.notificationId = '';

        this.fncSaveNotifications();
      },
      fncUpdateNotification() {

        this.canSave = true;

        var notificationSendDays = typeof this.notificationSendDays == 'string' ? this.notificationSendDays : this.notificationSendDays.join(',');

        this.statusNotificationList[this.notificationId].name = this.notificationName;
        this.statusNotificationList[this.notificationId].roles = this.notificationRole;
        this.statusNotificationList[this.notificationId].roles_ignore = this.notificationRoleIgnore;
        this.statusNotificationList[this.notificationId].branches = this.notificationBranches;
        this.statusNotificationList[this.notificationId].direct = this.notificationDirectReport;
        this.statusNotificationList[this.notificationId].report_vendors = this.notificationReportVendors;
        this.statusNotificationList[this.notificationId].departments = this.notificationDepartments;
        this.statusNotificationList[this.notificationId].vendors = this.notificationVendors;
        this.statusNotificationList[this.notificationId].type_id = this.notificationType;
        this.statusNotificationList[this.notificationId].notification_quote_type = this.notificationQuoteType;
        this.statusNotificationList[this.notificationId].notification_service_type = this.notificationServiceType;
        this.statusNotificationList[this.notificationId].status_status = this.notifyStatusStatus;
        this.statusNotificationList[this.notificationId].status_days = this.notifyStatusDays;
        this.statusNotificationList[this.notificationId].status_hours = this.notifyStatusHours;
        this.statusNotificationList[this.notificationId].years = this.notificationYears;
        this.statusNotificationList[this.notificationId].hours = this.notificationHours;
        this.statusNotificationList[this.notificationId].days = this.notificationDays;
        this.statusNotificationList[this.notificationId].message = this.repWysiwig;
        this.statusNotificationList[this.notificationId].customer_message = this.customerWysiwig;
        this.statusNotificationList[this.notificationId].method = this.notificationMethod;
        this.statusNotificationList[this.notificationId].notify_customer = this.notifyCustomer;
        this.statusNotificationList[this.notificationId].notify_vendor = this.notifyVendor;
        this.statusNotificationList[this.notificationId].notify_originator = this.notifyOriginator;
        this.statusNotificationList[this.notificationId].is_callout = this.isCallout == true || this.isCallout == 1 ? 1 : 0;
        this.statusNotificationList[this.notificationId].is_per_store = this.notifyIsStore == true || this.notifyIsStore == 1 ? 1 : 0;
        this.statusNotificationList[this.notificationId].notification_send_days = notificationSendDays;
        this.statusNotificationList[this.notificationId].notify_kam = this.notifyKam;
        this.statusNotificationList[this.notificationId].notify_coordinator = this.notifyCoordinator;
        this.statusNotificationList[this.notificationId].notify_daily = this.notifyDaily;
        this.statusNotificationList[this.notificationId].notification_time = this.notificationTime;
        this.statusNotificationList[this.notificationId].quote_value = this.notificationValue;
        this.statusNotificationList[this.notificationId].age = this.notificationAge;
        this.statusNotificationList[this.notificationId].subject = this.notificationSubject;
        this.statusNotificationList[this.notificationId].notification_attachment_categories = this.notificationCats;
        this.statusNotificationList[this.notificationId].notification_attachment_categories_users = this.notificationUserCats;
        this.statusNotificationList[this.notificationId].customer_subject = this.notificationCustomerSubject;
        this.statusNotificationList[this.notificationId].sms_message = this.notificationSmsMessage;
        this.statusNotificationList[this.notificationId].whatsapp_template = this.notificationWhatsappTemplate;
        this.statusNotificationList[this.notificationId].whatsapp_template_customer = this.notificationWhatsappTemplateCustomer;

        if( this.hideInternalTemplate == true && this.notificationWhatsappTemplate != '' && this.notificationWhatsappTemplate != '0' ) {
          this.statusNotificationList[this.notificationId].sms_message = this.fncCollectTwilioTemplateVariables('templateMessageInternalHolder', this.notificationWhatsappTemplate);
        }

        this.statusNotificationList[this.notificationId].customer_sms_message = this.notificationCustomerSmsMessage;

        if( this.hideCustomerTemplate == true && this.notificationWhatsappTemplateCustomer != '' && this.notificationWhatsappTemplateCustomer != '0' ) {
          this.statusNotificationList[this.notificationId].customer_sms_message = this.fncCollectTwilioTemplateVariables('templateMessageCustomerHolder', this.notificationWhatsappTemplateCustomer);
        }

        this.statusNotificationList[this.notificationId].add_pdf = this.notifyAddPdf == true || this.notifyAddPdf == 1 ? 1 : 0;
        this.statusNotificationList[this.notificationId].attach_delivery_note = this.attachDeliveryNote == true || this.attachDeliveryNote == 1 ? 1 : 0;
        this.statusNotificationList[this.notificationId].attach_delivery_note_customer = this.attachDeliveryNoteCustomer == true || this.attachDeliveryNoteCustomer == 1 ? 1 : 0;
        this.statusNotificationList[this.notificationId].attach_service_form_full = this.attachServiceFormFull == true || this.attachServiceFormFull == 1 ? 1 : 0;
        this.statusNotificationList[this.notificationId].attach_service_form_client = this.attachServiceFormClient == true || this.attachServiceFormClient == 1 ? 1 : 0;
        this.statusNotificationList[this.notificationId].attach_service_form_full_customer = this.attachServiceFormFullCustomer == true || this.attachServiceFormFullCustomer == 1 ? 1 : 0;
        this.statusNotificationList[this.notificationId].attach_service_form_client_customer = this.attachServiceFormClientCustomer == true || this.attachServiceFormClientCustomer == 1 ? 1 : 0;
        this.statusNotificationList[this.notificationId].add_pdf_po_vendor = this.notifyAddPoPdfVendor == true || this.notifyAddPoPdfVendor == 1 ? 1 : 0;
        this.statusNotificationList[this.notificationId].add_pdf_customer = this.notifyAddPdfCustomer == true || this.notifyAddPdfCustomer == 1 ? 1 : 0;
        this.statusNotificationList[this.notificationId].add_pdf_so_customer = this.notifyAddPdfSoCustomer == true || this.notifyAddPdfSoCustomer == 1 ? 1 : 0;
        this.statusNotificationList[this.notificationId].api_data = this.apiData;
        this.statusNotificationList[this.notificationId].notification_send_days = notificationSendDays;
        this.viewList = !this.viewList;
        this.notificationFormKey++;
        this.notificationId = '';    
        this.$store.commit('setGlobalModalTitle', this.globalModalParams.statusName);
        this.fncSaveNotifications();
      },
      fncCheckType() {
        if (this.notificationType == '1' ) {
          this.notificationYears = 0;
          this.notificationHours = 0;
          this.notificationDays = 0;
          /*this.notificationReportTypes = [
            { id: false, name: 'Send as trigger even occurs' },
            { id: true, name: 'Send summary at the end of the day' }
          ]
          this.notifyDaily = '';*/
        } /*else {
              this.notificationReportTypes = [
                { id: true, name: 'Send summary at the end of the day' }
              ]
              this.notifyDaily = true;
            }*/

      },
      fncSaveNotifications() {

        if( this.statusNotificationList.length > 0 ) {
          for( var n in this.statusNotificationList ) {
            if( typeof this.statusNotificationList[n].notification_attachment_categories != 'object' ) {
              this.statusNotificationList[n].notification_attachment_categories = this.statusNotificationList[n].notification_attachment_categories.split(',');
            }
            if( typeof this.statusNotificationList[n].notification_attachment_categories_users != 'object' ) {
              this.statusNotificationList[n].notification_attachment_categories_users = this.statusNotificationList[n].notification_attachment_categories_users.split(',');
            }
          }
        }

        this.$store.dispatch({
          type: 'fncSaveNotifications',
          status: this.globalModalParams.statusId,
          notifications: this.statusNotificationList
        })
        this.fncSetupWysiwigs('','');
        /*this.repWysiwig.setContent('');
        this.customerWysiwig.setContent('');*/
      },
      fncGetType(typeId) {
        for (var t in this.notificationTypes ) {
          if (this.notificationTypes[t].id == typeId ) {
            return this.notificationTypes[t].name
          }
        }
        return 'API Call';
      },
      fncCheckMethodList(meth) {

        if (this.notificationMethod.indexOf(meth) > -1 ) {
          return true;
        }
        return false;
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'runAdd',
        'userRoles',
        'statusNotificationList',
        'vendorManufacturerLinks',
        'departmentList',
        'branchList',
        'globalModalTitle',
        'statusList',
        'repUsers',
        'attachmentCategories',
        'whatsappTemplates'
      ])
    },
    created() {
      this.$store.dispatch('fncPopulateWhatsappTemplates');
      this.$store.dispatch('fncPopulateRoles');
      this.$store.dispatch('fncPopulateDepartments');
      this.$store.dispatch('fncPopulateBranches');
      this.$store.dispatch('fncPopulateStatusList');
      this.$store.dispatch({
        type: 'fncPopulateUsers',
        context: 1,
        parent: -1
      });
    },
    beforeMount() {

      // this.departmentListSet = [{0: 'All'}];
      this.departmentListSet = [];

      for( var d in this.departmentList ) {
        var objDeps = this.globalModalParams.statusDepartment.split(',');
        for( var od in objDeps ) {
          objDeps[od] = parseInt(objDeps[od]);
        }
        if( objDeps.indexOf( this.departmentList[d].id ) != -1 ) {
          this.departmentListSet.push( this.departmentList[d] );
          // this.notificationDepartments.push( this.departmentList[d].id );
        }
      }

    

    },
    mounted() {

      this.$store.dispatch('fncGetAttachmentCategories');
      /*if( this.branchList[0].id != 0 ){
        this.branchList.unshift({id: 0, name: 'All'});
        this.notificationBranches.unshift(0);
      }
      if( this.departmentList[0].id != 0 ) {
        this.departmentListSet.unshift({id: 0, name: 'All'});
        this.notificationDepartments.unshift(0);
      }*/
     /* this.departmentListSet = [];

      for( var d in this.departmentList ) {
        var objDeps = this.globalModalParams.statusDepartment.split(',');
        for( var od in objDeps ) {
          objDeps[od] = parseInt(objDeps[od]);
        }
        if( objDeps.indexOf( this.departmentList[d].id ) != -1 ) {
          this.departmentListSet.push( this.departmentList[d] );
          // this.notificationDepartments.push( this.departmentList[d].id );
        }
      }*/

      if( this.userRoles.length > 0 ) {
        for( var u in this.userRoles ) {
          if( this.userRoles[u].user_type == 6 ) {
            this.filteredUserTypesVendors.push(this.userRoles[u]);
          }
        }
      }

      if( this.filteredUserTypes.length == 0 ) {
        for( var u in this.userRoles ) {
          if( this.userRoles[u].user_type == 1 ) {
          //if( this.userRoles[u].user_type == 1 || this.userRoles[u].user_type == 6 ) {
            this.filteredUserTypes.push(this.userRoles[u]);
          }
          if( this.userRoles[u].user_type == 6 ) {
            this.vendorType.push(this.userRoles[u].id);
          }
        }
      }

      if( this.branchList.length != 0 && ( this.branchList[0].id != '0' || this.branchList[0].id != 0 ) ) {
        this.branchList.unshift({id: 0, name: 'All'});
      }

      if( this.departmentListSet.length != 0 && ( this.departmentListSet[0].id != '0' || this.departmentListSet[0].id != 0 ) ) {
        this.departmentListSet.unshift({id: 0, name: 'All'});
      }

      if( this.vendorManufacturerLinks.length != 0 && ( this.vendorManufacturerLinks[0].id != '0' || this.vendorManufacturerLinks[0].id != 0 ) ) {
        this.vendorManufacturerLinks.unshift({id: 0, name: 'All'});
      }

      this.notificationListSet = this.statusNotificationList;

      this.notificationDepartmentList = [{id: 0, name: 'All Departments'}];
      for( var d in this.departmentList ) {
        if( this.departmentList[d].id != 0 ) {
          this.notificationDepartmentList.push({id: this.departmentList[d].id, name: this.departmentList[d].name});
        }
      }


      //this.fncFilterNotifications();

    },
    watch: {
      statusNotificationList() {
        this.notificationListSet = this.statusNotificationList;
      },
      notifyAddPdfCustomer() {
        if( this.notifyAddPdfCustomer == true ) {
          this.notifyAddPdfSoCustomer = false;
        }
      },
      notifyAddPdfSoCustomer() {
        if( this.notifyAddPdfSoCustomer == true ) {
          this.notifyAddPdfCustomer = false;
        }
      },
      notifyAddPoPdfVendor() {
        if( this.notifyAddPoPdfVendor == true ) {
          this.notifyAddPdf = false;
        }
      },
      notifyAddPdf() {
        if( this.notifyAddPdf == true ) {
          this.notifyAddPoPdfVendor = false;
        }
      },
      /*notificationBranches() {
        if( this.notificationBranches.length == 1 && this.notificationBranches[0] == '0' ) {
          alert('here');
          this.notificationBranches = [];
          this.notificationBranches.push(0);

          for( var b in this.branchList ) {
            this.notificationBranches.push(this.branchList[b].id);
          }
        }
      },*/
      departmentListSet() {
        /*if( this.departmentListSet[1].id == '0' ) {
          this.departmentListSet.splice(1, 1);
        }*/
      },
      userRoles() {
        for( var u in this.userRoles ) {
          /*if( this.userRoles[u].user_type == 1 || this.userRoles[u].user_type == 6 ) {*/
          if( this.userRoles[u].user_type == 1 ) {
            this.filteredUserTypes.push(this.userRoles[u]);
          }
          if( this.userRoles[u].user_type == 6 ) {
            this.vendorType.push(this.userRoles[u].id);
          }
        }
        for( var u in this.userRoles ) {
          if( this.userRoles[u].user_type == 6 ) {
            this.filteredUserTypesVendors.push(this.userRoles[u]);
          }
        }
      },
      branchList() {
        if( this.branchList.length > 0 && this.branchList[0].id != 0 ){
          this.branchList.unshift({id: 0, name: 'All'});
          this.allBranches = true;
          this.notificationBranches = [];
          this.notificationBranches.push(0);
        }
        if( this.branchList.length > 0 && this.departmentList[0].id != 0 ) {
          this.departmentListSet.unshift({id: 0, name: 'All'});
          this.allDepartments = true;
          this.notificationDepartments = [];
          this.notificationDepartments.push(0);
        }
      },
      departmentList() {
        if( this.departmentList.length > 0 && this.departmentList[0].id != 0 ){
          this.departmentList.unshift({id: 0, name: 'All'});
          this.allDepartments = true;
          this.notificationDepartments = [];
          this.notificationDepartments.push(0);
        }
      }
    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>
